<template>
<div class="lottery">
	<van-nav-bar :title="showtitle" left-text="" @click-left="back()" @click-right="showRight ? showRight = false : showRight = true" left-arrow >
	  <template #right>
	    <span style="color:#fff;font-size: 0.8rem;">{{$t('switch')}}</span>
	  </template>
	</van-nav-bar>

	<div class="history" v-if="active" style="z-index: 2011;">
		<div class="">
			<div class="left">
				<p>
					{{$t('game.expect')}}
				</p>
				<ul>
					<li v-for="(v,key) in lottery_list" :key="key" >
						{{v.expect}}
					</li>					
				</ul>
			</div>
			<div class="right">
				<p>
					{{$t('game.jieguo')}}
				</p>
				<ul>
					<li class="mak" v-for="(v,key) in lottery_list" :key="key" >
						<div class="ball">
							<span :class="'idem'+v.opencode[0]"></span>
							<span :class="'idem'+v.opencode[1]"></span>
							<span :class="'idem'+v.opencode[2]"></span>
						</div>
						<div class="res">
							<span>
								{{v.opencode[0] + v.opencode[1] + v.opencode[2]}}
							</span>
							<span>
								{{getSizeText(v.opencode)}}
							</span>
							<span>
								{{getDoubleText(v.opencode)}}
							</span>
						</div>
					</li>
					
				</ul>
			</div>
		</div>
	</div>
	<!---->
	<div class="top">
		<div class="qs">
			<div>
				<div class="ico">
					<img :src="showimage" alt="">
				</div>
				<h1>
					{{this.lottery.next_expect}}
				</h1>
			</div>
			<span style="font-size: 13px;">
				<span style="font-size: 13px; color: rgb(255, 255, 255); margin-right: 10px;">
					{{$t('game.lefttime')}}:
				</span>
				<van-count-down :time="time" @finish="check()" />
			</span>
		</div>
		<div class="number">
			<div class="left">
				<div class="ball">
					<p>
						{{this.lottery.now_expect}}
						<br>
						{{$t('game.lunci')}}
					</p>
				</div>
			</div>
			<div class="right">
				<div class="res">
					<span>
						{{this.sum}}
					</span>
					<span>
						{{this.size}}
					</span>
					<span>
						{{this.double}}
					</span>
				</div>
				<van-icon name="arrow-down" :class="{ up: active,down:!active }" @click="active ? active = false : active = true" />
			</div>
		</div>
	</div>
	<div class="lottery-content">
		<div class="left">
			<div class="item">
				<span>
					和值
				</span>
				<div class="active slide">
					两面
				</div>
				<div class="slide" style="display: none;">
					和值
				</div>
			</div>
			<div class="item">
				<!---->
				<div class="slide" style="display: none;">
					复选
				</div>
				<div class="slide" style="display: none;">
					标准选号
				</div>
			</div>
			<div class="item">
				<!---->
				<div class="slide" style="display: none;">
					标准选号
				</div>
			</div>
			<div class="item">
				<!---->
				<div class="slide" style="display: none;">
					通选
				</div>
			</div>
		</div>
		<div class="right" id="toBottom">
			<div class="ball" id="eidet" style="padding-bottom: 60px; transition: all 0.2s ease 0s;">
				<div>
					<div class="idx0" 
						:class="{
							active: choose[v.type],
							'auth-street': v.name && (v.name.includes('同街') || v.name.includes('同じ街') || v.type && (v.type.includes('同街') || v.type.includes('同じ街'))),
							'auth-country': v.name && (v.name.includes('同国') || v.name.includes('同じ国') || v.type && (v.type.includes('同国') || v.type.includes('同じ国')))
						}" 
						v-for="(v,key) in lottery_peilv_list" 
						:key="key" 
						@click="choosePlay(v.type,v.name);">
						<p >{{v.name && $t('game.'+v.name) !== 'game.'+v.name ? $t('game.'+v.name) : v.name}}</p>
						<span>
							({{v.proportion}})
						</span>
					</div>
					
				</div>
				<!---->
				<!---->
				<!---->
				<!----></div>
			
			<!-- 货币行情显示区域 - 主页面（在按钮下方，间距20px） -->
			<div class="main-quote-section">
				<p class="quote-section-title">行情</p>
				<div class="quote-list">
					<div 
						v-for="(quote, index) in currencyQuotes" 
						:key="index"
						class="quote-item"
					>
						<span class="quote-pair">{{quote.currency_pair}}</span>
						<span 
							class="quote-price" 
							:class="quote.priceChange > 0 ? 'price-up' : quote.priceChange < 0 ? 'price-down' : ''"
						>
							{{quote.currentPrice}}
						</span>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!---->
	<div class="mask animate__animated animate__fadeInUp" v-if="shopping">
		<div class="title">
			<p>
				{{$t('currentSelection')}}
				<span>
					{{ this.shopchoose}}
				</span>
			</p>
			<div>
				<i class="van-badge__wrapper van-icon van-icon-arrow">
					<!---->
					<!---->
					<!----></i>
				<i class="van-badge__wrapper van-icon van-icon-arrow">
					<!---->
					<!---->
					<!----></i>
			</div>
		</div>
		<div class="c1">
			<p>
				{{$t('quantity')}}
			</p>
			<input type="number" v-model="money">
			<p></p>
		</div>
		<div class="c2">
			<p>
				{{$t('total')}}
				<span>
					{{this.formData.length}}
				</span>
				{{$t('ticketAmount')}}
				<span>
					{{this.formData.length * this.money}}
				</span>
			</p>
		</div>
	</div>
	
	<van-popup v-model="showRight" position="right" :style="{ width: '65%' ,height: '100%'}" >
		<div class="popups"  @click="toLottery(v.key,v.id)" v-for="(v,key) in game_type_list" :key="key">
			<p >
				{{v.name}}
			</p>
		</div>
	</van-popup>
	
	<!-- 认证界面弹窗 - 底部上拉 -->
	<van-popup v-model="showAuthModal" position="bottom" :style="{ height: 'auto', maxHeight: '90%' }" get-container="body" class="auth-modal-popup" round>
	  <div class="auth-modal">
	      <div class="auth-header">
	        <van-icon name="arrow-left" @click="closeAuthModal()" />
	        <p class="auth-title">{{$t('game.authCenter')}}</p>
	        <van-icon name="cross" @click="closeAuthModal()" />
	      </div>
	      
	      <div class="auth-content">
        <!-- 认证类型标题：使用当前彩种完整名称（如 BTC/認証、ETH/認証），不再重复追加「/認証」 -->
        <div class="auth-type-header">
          <span class="auth-type-title">{{lottery.name || showtitle || 'BTC/認証'}}</span>
          <van-icon name="cross" @click="closeAuthModal()" />
        </div>
	        
	        <!-- 认证数据选择 -->
	        <div class="auth-section">
	          <p class="section-label">{{$t('game.authData')}}</p>
	          <div class="auth-duration-list">
	            <div 
	              v-for="(item, key) in authDurationList" 
	              :key="key"
	              class="auth-duration-item"
	              :class="{ active: authDuration === item.duration }"
	              @click="selectAuthDuration(item.duration)"
	            >
	              {{item.duration}} {{item.percent}}
	            </div>
	          </div>
	        </div>
	        
	        <!-- 认证金额 -->
	        <div class="auth-section">
	          <p class="section-label">{{$t('game.authAmount')}}</p>
	          <div class="auth-amount-input">
	            <input 
	              type="number" 
	              v-model="authAmount" 
	              @input="calculateAuthProfit()"
	              :placeholder="$t('game.plsmoney')"
	              class="amount-input"
	            />
	          </div>
	        </div>
	        
	        <!-- 账户余额 -->
	        <div class="auth-balance">
	          <p>{{$t('game.accountBalance')}}: <span>{{ userInfo.money || '0.00' }}</span></p>
	        </div>
	        
	        <!-- 交易详情表格 -->
	        <div class="auth-table">
	          <table>
	            <thead>
	              <tr>
	                <th>{{$t('game.tradingPair')}}</th>
	                <th>{{$t('game.direction')}}</th>
	                <th>{{$t('game.currentPrice')}}</th>
	                <th>{{$t('game.amount')}}</th>
	                <th>{{$t('game.estimatedProfit')}}</th>
	              </tr>
	            </thead>
	            <tbody>
	              <tr>
	                <!-- 取引ペア：同样只使用当前彩种名称，避免出现 \"ETH/認証/認証\" -->
	                <td>{{lottery.name || showtitle || 'BTC/認証'}}</td>
	                <td>{{authType}}</td>
	                <td class="price-cell">{{currentPrice}}</td>
	                <td>{{authAmount || '0'}}</td>
	                <td>{{estimatedProfit}}</td>
	              </tr>
	            </tbody>
	          </table>
	        </div>
	        
	        <!-- 提交按钮 - 在内容区域内，固定在底部 -->
	        <div class="auth-submit">
	          <van-button 
	            class="submit-btn" 
	            type="primary" 
	            @click="submitAuth()"
	          >
	            {{$t('game.submitAuth')}}
	          </van-button>
	        </div>
	      </div>
	  </div>
	</van-popup>
	
	<!-- 等待结果弹窗 -->
	<van-popup v-model="showWaitingModal" position="bottom" :style="{ height: 'auto', maxHeight: '90%' }" get-container="body" :close-on-click-overlay="false" class="waiting-modal-popup">
	  <div class="waiting-result-modal">
	    <!-- 顶部标题栏 -->
	    <div class="waiting-header-bar">
	      <van-icon name="arrow-left" @click="closeWaitingModal" />
	      <p class="waiting-header-title">{{$t('game.authCenter')}}</p>
	      <van-icon name="cross" @click="closeWaitingModal" />
	    </div>
	    
	    <div class="waiting-content-wrapper">
	      <!-- 彩种标题 -->
	      <div class="waiting-lottery-title">
	        {{lottery.name || showtitle || 'BTC/認証'}}
	      </div>
	      
	      <!-- 倒计时中 -->
	      <div v-if="!waitingResult" class="waiting-status">
	        <!-- 圆形倒计时器 -->
	        <div class="countdown-circle-large">
	          <svg class="countdown-svg" viewBox="0 0 200 200">
	            <circle
	              class="countdown-circle-bg"
	              cx="100"
	              cy="100"
	              r="90"
	              fill="none"
	              stroke="#e0e0e0"
	              stroke-width="8"
	            />
	            <circle
	              class="countdown-circle-progress"
	              cx="100"
	              cy="100"
	              r="90"
	              fill="none"
	              stroke="#ff253f"
	              stroke-width="8"
	              :stroke-dasharray="565.48"
	              :stroke-dashoffset="waitingInitialTime > 0 ? 565.48 - (565.48 * ((waitingInitialTime - waitingCountdown) / waitingInitialTime)) : 565.48"
	              stroke-linecap="round"
	              transform="rotate(-90 100 100)"
	            />
	          </svg>
	          <div class="countdown-number-large">{{waitingCountdown}}s</div>
	        </div>
	        
	        <!-- 数据列表 -->
	        <div class="waiting-data-list">
	          <div class="data-item">
	            <span class="data-label">{{$t('game.currentPrice')}}</span>
	            <span class="data-value price-value">{{waitingCurrentPrice}}</span>
	          </div>
	          <div class="data-item">
	            <span class="data-label">{{$t('game.cycle')}}</span>
	            <span class="data-value">{{authDuration}}</span>
	          </div>
	          <div class="data-item">
	            <span class="data-label">{{$t('game.type')}}</span>
	            <span class="data-value type-value">{{authType}}</span>
	          </div>
	          <div class="data-item">
	            <span class="data-label">{{$t('game.amount')}}</span>
	            <span class="data-value">{{authAmount || '0'}}</span>
	          </div>
	          <div class="data-item">
	            <span class="data-label">{{$t('game.buildPosition')}}</span>
	            <span class="data-value">{{waitingBuyPrice}}</span>
	          </div>
	          <div class="data-item">
	            <span class="data-label">{{$t('game.estimatedProfit')}}</span>
	            <span class="data-value profit-value" :class="getWaitingProfitClass()">{{getWaitingProfit()}}</span>
	          </div>
	        </div>
	      </div>
	      
	      <!-- 结果显示 -->
	      <div v-else class="result-status">
	        <div class="result-icon" :class="waitingResult.isWin ? 'win' : 'lose'">
	          <van-icon :name="waitingResult.isWin ? 'success' : 'cross'" />
	        </div>
	        <p class="result-text" :class="waitingResult.isWin ? 'win' : 'lose'">
	          {{waitingResult.isWin ? $t('game.win') : $t('game.lose')}}
	        </p>
	        <!-- 显示盈亏数额 -->
	        <p class="result-profit">
	          {{$t('game.profit')}}: <span :class="getResultProfitClass()">{{waitingResult.profit !== null && waitingResult.profit !== undefined ? waitingResult.profit : getWaitingProfit()}}</span>
	        </p>
	        <p class="result-message">{{waitingResult.message || ''}}</p>
	        
	        <!-- 关闭按钮 -->
	        <div class="result-close-btn-wrapper">
	          <van-button type="primary" @click="closeWaitingModal" class="result-close-btn">
	            {{$t('game.close')}}
	          </van-button>
	        </div>
	      </div>
	      
	      <!-- 底部状态栏 - 只在倒计时中显示 -->
	      <div v-if="!waitingResult" class="waiting-footer-bar">
	        <span>{{$t('game.authenticating')}}</span>
	      </div>
	    </div>
	  </div>
	</van-popup>
	
	<!-- 原有的订单确认弹窗 -->
	<van-popup v-model="jiesuanpage" get-container="body" >
	  <div class="confirm-order-modal">
	      <div class="head van-hairline--bottom">
	        <p class="text">{{$t('game.order')}}</p>
	      </div>
	      <ui class="list">
	          <li v-for="(v,key) in formData" :key="key" class="lise-item van-hairline--bottom">
	              <div class="main">
	                <p class="bet-name">{{v.name && $t('game.'+v.name) !== 'game.'+v.name ? $t('game.'+v.name) : v.name}}</p>
	                <p class="detail-text">1X{{ money }}={{ money }}</p>
	              </div>
	              <van-icon @click="clearChooes(v.type)" name="close" />
	          </li>
	      </ui>
	      <div class="sub-bar">
	        <van-button class="item cancel-btn" type="default" @click="allClear()">{{$t('game.clear')}}</van-button>
	        <van-button class="item sub-btn" type="default" @click="doSub">{{$t('game.submit')}}</van-button>
	      </div>
	  </div>
	</van-popup>
	
	<div class="foot">
		<p>
			{{$t('availablePoints')}}
			<span>{{ this.userInfo.money }}</span>
		</p>
		<a  @click="jiesuan()">
			{{$t('verify')}}
		</a>
	</div>
	<!---->
	<!---->
	<!---->
	<!----></div>
</template>

<script>
var time;
var count = 0;
export default {
  data() {
    return {
      jiesuanpage:false,
      choose: {
        "大":false,
        "小":false,
        "单":false,
        "双":false,
        "3":false,
        "4":false,
        "5":false,
        "6":false,
        "7":false,
        "8":false,
        "9":false,
        "10":false,
        "11":false,
        "12":false,
        "13":false,
        "14":false,
        "15":false,
        "16":false,
        "17":false,
        "18":false,
      },
      playgame:false,
      shopping:false,
      isLoading: false,
      showRight: false,
	  game_type_list: [{},{},{},{}],
	  showimage:'',
	  title:'',
	  showtitle:'',
      play:{},
      lottery_peilv_list:{},
      lottery_list:{},
      active: false,
      userInfo:{},
      lottery:{},
      shanzi_1:"0",
      shanzi_2:"0",
      shanzi_3:"0",
      sum:0,
      size:"",
      double:"",
      time:0,
      shopchoose:"未选择",
      gameitem:"",
      formData:[],
      money:"",
      // 认证界面相关数据
      showAuthModal: false,
      authType: '', // 认证类型：同街认证 或 同国认证
      authDuration: '120s', // 选中的认证时长
      authDurationList: [
        { duration: '120s', percent: '30%' },
        { duration: '180s', percent: '35%' },
        { duration: '240s', percent: '40%' },
        { duration: '300s', percent: '45%' },
        { duration: '360s', percent: '50%' }
      ],
      authAmount: '', // 认证金额
      currentPrice: '0.00', // 当前价格
      estimatedProfit: '0.00', // 预估利润
      priceMin: 0.00, // 价格最低值（从后端获取）
      priceMax: 0.00, // 价格最高值（从后端获取）
      priceUpdateTimer: null, // 价格更新定时器
      // 货币行情相关数据
      currencyQuotes: [], // 货币行情列表
      quoteUpdateTimer: null, // 行情更新定时器（每5秒更新一次）
      // 等待结果界面相关数据
      showWaitingModal: false, // 显示等待结果弹窗
      waitingCountdown: 0, // 倒计时（秒，实时根据开始时间计算）
      waitingInitialTime: 0, // 初始倒计时时间（秒）
      waitingStartTime: null, // 倒计时开始的时间戳（ms）
      waitingTimer: null, // 倒计时定时器
      waitingResult: null, // 等待结果数据
      waitingOrderId: null, // 等待的订单ID
      waitingExpect: null, // 等待的期号（用于查找订单）
      waitingLid: null, // 等待的彩种ID（用于查找订单）
      waitingBuyPrice: '0.00', // 购买时的价格
      waitingCurrentPrice: '0.00', // 等待界面中的当前价格（浮动）
      waitingPriceTimer: null, // 等待界面价格更新定时器
      waitingRealProfit: null, // 真实的盈亏（从后端获取）
      waitingForceLose: false, // 强制亏损状态（从后端获取）
      waitingForceLoseTimer: null, // 检查强制亏损状态的定时器
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    getSizeText(opencode) {
      const sum = opencode[0] + opencode[1] + opencode[2];
      if (sum >= 11 && sum <= 18) {
        return this.$t('game.da');
      } else {
        return this.$t('game.xiao');
      }
    },
    getDoubleText(opencode) {
      const sum = opencode[0] + opencode[1] + opencode[2];
      if (sum % 2 === 0) {
        return this.$t('game.shuang');
      } else {
        return this.$t('game.dan');
      }
    },
    updateGameInfo(key, id) {
      // 从游戏类型列表中查找对应的游戏信息
      const gameInfo = this.game_type_list.find(game => game.key === key && game.id === id);
      if (gameInfo) {
        this.showtitle = gameInfo.name;
        this.showimage = gameInfo.ico || gameInfo.logo_pic;
      }
    },
	toLottery(key,id){
	  if(!localStorage.getItem('token')){
	    this.$router.push({path:'/Login'})
	  }else {
	    // 如果已经在Lottery页面，则更新查询参数并重新获取数据
	    if(this.$route.name === 'Lottery') {
	      // 先更新标题和图片
	      this.updateGameInfo(key, id);
	      // 更新路由参数
	      this.$router.replace({path:'/Lottery', query:{key:key, id:id}})
	      // 重新获取数据
	      this.getLotteryInfo();
	      this.getLotteryList();
	      this.getLotteryPeilv();
	    } else {
	      this.$router.push({path:'/Lottery', query:{key:key, id:id}})
	    }
	  }
	  // 关闭弹窗
	  this.showRight = false;
	},
    doSub(){
      if(this.money === "0"){
        this.$toast(this.$t('game.plsmoney'));
        return false;
      }
      if(this.formData.length === 0){
        this.$toast(this.$t('game.plsnum'));
        return false;
      }else if(this.money === ""){
        this.$toast(this.$t('game.plsmoney'));
        return false;
      } else {
        if(this.userInfo.money - (this.money * this.formData.length) < 0 ){
          this.$toast(this.$t('game.moneynote'));
          return false;
        }else {
          this.$http({
            method: 'post',
            data:{
               item:this.gameitem,
               money:this.money,
               lid:this.lottery.id,
               mid:this.userInfo.id,
               expect:this.lottery.now_expect
            },
            url: 'game_place_order'
          }).then(res=>{
            if(res.code === 200){
              this.$toast(res.msg);
              this.allClear();
              this.getUserInfo();
            }else if(res.code === 401){
              this.$toast(res.msg);
            }
          })
          return true;
        }
      }
    },
    allClear(){
      for(var i = 0;i<this.formData.length;i++){
          this.choose[this.formData[i]['type']] = false;
      }
      this.formData.length = 0;
      this.money = "";
      this.shopchoose = "未选中";
      this.gameitem ="";
      this.shopping = false;
      this.jiesuanpage = false;
    },
    jiesuan(){
      if(this.formData.length === 0){
        this.$toast(this.$t('game.plsnum'));
        return false;
      }else if(this.money === ""){
        this.$toast(this.$t('game.plsmoney'));
        return false;
      }
      else {
        // this.jiesuanpage ? this.jiesuanpage = false : this.jiesuanpage = true;
		this.doSub();
      }

    },
    clearChooes(type){
      for(var i = 0;i<this.formData.length;i++){
        if(type === this.formData[i]['type'] ){
          this.formData.splice(i,1)
          this.choose[type] = false;
        }
      }
      if(this.formData.length >= 1){
        for(var j = 0;j < this.formData.length;j++){
    		let sname = this.formData[j]['name'];
          if(j === 0){
            this.shopchoose = this.$t("game."+sname);
            this.gameitem = this.formData[j]['type'];
          }else {
            this.shopchoose += ","+this.$t("game."+sname);
            this.gameitem   += "," + this.formData[j]['type'];
          }
        }
      }else {
        this.shopchoose = "未选中";
        this.gameitem = "";
        this.shopping = false;
      }
      if(this.formData.length === 0){
        this.jiesuanpage = false;
      }
    },
    choosePlay(type,name){
        // 检查是否是单、双、同街认证或同国认证 - 这些都应该弹出认证界面
        const nameStr = String(name || '').trim();
        const typeStr = String(type || '').trim();
        
        // 检查是否是单、双、同街认证或同国认证
        const authKeywords = ['同街', '同国', '同じ街', '同じ国', 'streetAuth', 'countryAuth'];
        const isAuthType = authKeywords.some(keyword => 
          nameStr.includes(keyword) || 
          typeStr.includes(keyword) ||
          nameStr.toLowerCase().includes(keyword.toLowerCase()) ||
          typeStr.toLowerCase().includes(keyword.toLowerCase())
        );
        
        // 检查是否是单或双
        const isSingleOrDouble = typeStr === '单' || typeStr === '双' || 
                                 nameStr === '单' || nameStr === '双' ||
                                 typeStr === '奇' || typeStr === '偶' ||
                                 nameStr === '奇' || nameStr === '偶' ||
                                 this.$t('game.单') === nameStr || this.$t('game.双') === nameStr ||
                                 this.$t('game.单') === typeStr || this.$t('game.双') === typeStr;
        
        // 如果是认证类型或单双，都弹出认证界面
        if(isAuthType || isSingleOrDouble) {
          // 显示认证界面
          let authTypeValue = '';
          
          // 优先判断name和type中是否包含"同街"或"同国"关键词（优先判断，避免被单双逻辑覆盖）
          if(nameStr && (nameStr.includes('同街') || nameStr.includes('同じ街'))) {
            // 同街认证
            authTypeValue = nameStr.includes('同じ街') ? '同じ街認証' : '同街认证';
          } else if(nameStr && (nameStr.includes('同国') || nameStr.includes('同じ国'))) {
            // 同国认证
            authTypeValue = nameStr.includes('同じ国') ? '同じ国認証' : '同国认证';
          } else if(typeStr && (typeStr.includes('同街') || typeStr.includes('同じ街'))) {
            // 同街认证
            authTypeValue = typeStr.includes('同じ街') ? '同じ街認証' : '同街认证';
          } else if(typeStr && (typeStr.includes('同国') || typeStr.includes('同じ国'))) {
            // 同国认证
            authTypeValue = typeStr.includes('同じ国') ? '同じ国認証' : '同国认证';
          } else if(typeStr === '单' || nameStr === '单' || typeStr === '奇' || nameStr === '奇' || 
             this.$t('game.单') === nameStr || this.$t('game.单') === typeStr) {
            // 单 → 同国认证
            authTypeValue = '同国认证';
          } else if(typeStr === '双' || nameStr === '双' || typeStr === '偶' || nameStr === '偶' ||
                    this.$t('game.双') === nameStr || this.$t('game.双') === typeStr) {
            // 双 → 同街认证
            authTypeValue = '同街认证';
          } else {
            authTypeValue = type || name;
          }
          
          this.authType = authTypeValue;
          this.showAuthModal = true;
          // 初始化认证金额
          if(!this.authAmount) {
            this.authAmount = '';
          }
          // 重置认证时长
          this.authDuration = '120s';
          // 获取货币行情
          this.getCurrencyQuotes();
          // 重置价格
          this.currentPrice = '0.00';
          this.estimatedProfit = '0.00';
          // 停止之前的定时器
          if(this.priceUpdateTimer) {
            clearInterval(this.priceUpdateTimer);
            this.priceUpdateTimer = null;
          }
          return;
        }
        
        // 原有的选择逻辑
        if(this.choose[type] === true){
          this.choose[type] = false;
          for(var i = 0;i<this.formData.length;i++){
            if(type === this.formData[i]['type'] ){
                this.formData.splice(i,1)
            }
          }
        }else if(this.choose[type] === false) {
          this.formData.push({'name':name, 'type':type})
          this.choose[type] = true;
        }
        if(this.formData.length === 1){
          this.shopping = true;
        }
        if(this.formData.length >= 1){
          for(var j = 0;j < this.formData.length;j++){
    		  let sname = this.formData[j]['name'];
            if(j === 0){
              this.shopchoose = this.$t("game."+sname);
              this.gameitem = this.formData[j]['type'];
            }else {
              this.shopchoose += ","+this.$t("game."+sname);
              this.gameitem += ","+this.formData[j]['type'];
            }
          }
        }else {
          this.shopchoose = "未选中";
          this.gameitem = "";
          this.shopping = false;
        }
    
    },
    // 选择认证时长
    selectAuthDuration(duration) {
      this.authDuration = duration;
      this.calculateAuthProfit();
    },
    // 计算认证利润
    calculateAuthProfit() {
      if(!this.authAmount || parseFloat(this.authAmount) <= 0) {
        this.currentPrice = '0.00';
        this.estimatedProfit = '0.00';
        // 停止价格更新定时器
        if(this.priceUpdateTimer) {
          clearInterval(this.priceUpdateTimer);
          this.priceUpdateTimer = null;
        }
        return;
      }
      // 根据选中的时长获取百分比
      const selectedDuration = this.authDurationList.find(item => item.duration === this.authDuration);
      if(selectedDuration) {
        const percent = parseFloat(selectedDuration.percent.replace('%', ''));
        const amount = parseFloat(this.authAmount);
        // 预估利润 = 金额 * 百分比 / 100
        this.estimatedProfit = (amount * percent / 100).toFixed(2);
        
        // 启动价格自动浮动
        this.startPriceFluctuation(amount);
      }
    },
    // 开始价格浮动
    startPriceFluctuation(amount) {
      // 清除之前的定时器
      if(this.priceUpdateTimer) {
        clearInterval(this.priceUpdateTimer);
      }
      
      // 立即计算一次价格
      this.updateCurrentPrice(amount);
      
      // 每1秒更新一次价格
      this.priceUpdateTimer = setInterval(() => {
        this.updateCurrentPrice(amount);
      }, 1000);
    },
    // 更新当前价格（在区间内随机浮动）
    updateCurrentPrice(amount) {
      if(!amount || amount <= 0) {
        this.currentPrice = '0.00';
        return;
      }
      
      // 如果价格区间未配置或为0，则不显示价格
      if(!this.priceMin || !this.priceMax || this.priceMin >= this.priceMax) {
        this.currentPrice = '0.00';
        return;
      }
      
      // 在配置的价格区间内生成随机价格（保留2位小数）
      const randomPrice = this.priceMin + Math.random() * (this.priceMax - this.priceMin);
      this.currentPrice = randomPrice.toFixed(2);
    },
    // 获取货币行情配置
    getCurrencyQuotes(){
      this.$http({
        method: 'get',
        url: 'sys_get_currency_quotes'
      }).then(res=>{
        if(res.code === 200){
          // 初始化行情数据，为每个货币对生成初始价格
          this.currencyQuotes = res.data.map(quote => {
            const initialPrice = quote.price_min + Math.random() * (quote.price_max - quote.price_min);
            return {
              currency_pair: quote.currency_pair,
              price_min: quote.price_min,
              price_max: quote.price_max,
              currentPrice: initialPrice.toFixed(2),
              priceChange: 0 // 价格变化：1上涨，-1下跌，0不变
            };
          });
          // 启动行情更新定时器
          this.startQuoteUpdate();
        }else if(res.code === 401){
          this.$toast(res.msg);
        }
      })
    },
    // 开始行情更新（每5秒更新一次）
    startQuoteUpdate(){
      // 清除之前的定时器
      if(this.quoteUpdateTimer) {
        clearInterval(this.quoteUpdateTimer);
      }
      
      // 立即更新一次
      this.updateCurrencyQuotes();
      
      // 每5秒更新一次
      this.quoteUpdateTimer = setInterval(() => {
        this.updateCurrencyQuotes();
      }, 5000);
    },
    // 更新货币行情价格
    updateCurrencyQuotes(){
      this.currencyQuotes.forEach(quote => {
        if(quote.price_min && quote.price_max && quote.price_min < quote.price_max){
          const oldPrice = parseFloat(quote.currentPrice);
          // 在区间内生成随机价格
          const newPrice = quote.price_min + Math.random() * (quote.price_max - quote.price_min);
          const newPriceFloat = parseFloat(newPrice.toFixed(2));
          
          // 判断涨跌
          if(newPriceFloat > oldPrice){
            quote.priceChange = 1; // 上涨（绿色）
          } else if(newPriceFloat < oldPrice){
            quote.priceChange = -1; // 下跌（红色）
          } else {
            quote.priceChange = 0; // 不变
          }
          
          quote.currentPrice = newPriceFloat.toFixed(2);
        }
      });
    },
    // 停止行情更新
    stopQuoteUpdate(){
      if(this.quoteUpdateTimer) {
        clearInterval(this.quoteUpdateTimer);
        this.quoteUpdateTimer = null;
      }
    },
    // 关闭认证弹窗
    closeAuthModal(){
      this.showAuthModal = false;
      // 停止行情更新
      this.stopQuoteUpdate();
    },
    // 提交认证
    submitAuth() {
      if(!this.authAmount || parseFloat(this.authAmount) <= 0) {
        this.$toast(this.$t('game.plsmoney'));
        return;
      }
      if(parseFloat(this.authAmount) > parseFloat(this.userInfo.money || 0)) {
        this.$toast(this.$t('game.moneynote'));
        return;
      }
      // 根据认证类型映射到单双选项（与展示规则保持一致）：
      // 同じ街認証 / 同街认证 → 单（奇数）
      // 同じ国認証 / 同国认证 → 双（偶数）
      const typeStr = String(this.authType || '');
      let betType = '单';
      if (
        typeStr.includes('同街') ||
        typeStr.includes('同じ街')
      ) {
        betType = '单';
      } else if (
        typeStr.includes('同国') ||
        typeStr.includes('同じ国')
      ) {
        betType = '双';
      }
      
      // 调用后端接口提交认证订单（所有时长共用同一个单双选项）
      this.$http({
        method: 'post',
        data: {
          item: betType, // 根据认证类型映射的单双选项
          money: this.authAmount,
          lid: this.lottery.id,
          mid: this.userInfo.id,
          expect: this.lottery.now_expect,
          duration: this.authDuration, // 传递时长信息（仅用于展示）
          type: this.authType // 传递认证类型（同じ街認証 / 同じ国認証）
        },
        url: 'game_place_order'
      }).then(res => {
        if(res.code === 200) {
          this.$toast.success(res.msg);
          this.showAuthModal = false;
          
          // 保存订单ID（如果后端返回）
          this.waitingOrderId = res.data?.order_id || res.data?.id || null;
          
          // 保存期号和彩种ID（用于查找订单）
          this.waitingExpect = this.lottery?.now_expect || null;
          this.waitingLid = this.lottery?.id || null;
          
          console.log('保存订单信息 - waitingOrderId:', this.waitingOrderId, 'waitingExpect:', this.waitingExpect, 'waitingLid:', this.waitingLid);
          
          // 保存购买时的价格
          this.waitingBuyPrice = this.currentPrice || '0.00';
          this.waitingCurrentPrice = this.currentPrice || '0.00';
          
          // 如果后端在提交订单时返回了盈亏数据，直接使用
          if(res.data) {
            const profit = res.data.profit || res.data.profit_amount || res.data.profitAmount || 
                          res.data.amount || res.data.money || res.data.real_profit || null;
            if(profit !== null && profit !== undefined) {
              this.waitingRealProfit = parseFloat(profit);
              console.log('从提交订单接口获取的真实盈亏:', this.waitingRealProfit);
            }
          }
          
          // 启动等待界面
          this.startWaiting();
          
          // 停止认证界面的价格更新定时器
          if(this.priceUpdateTimer) {
            clearInterval(this.priceUpdateTimer);
            this.priceUpdateTimer = null;
          }
          
          // 等待界面关闭后再重置这些数据
          // 这里先不重置，等等待界面关闭时再重置
          
          this.getUserInfo();
        } else {
          this.$toast(res.msg);
        }
      });
    },
    // 启动等待界面
    startWaiting() {
      // 从时长字符串中提取秒数（如 "120s" -> 120）
      const durationStr = this.authDuration || '120s';
      const seconds = parseInt(durationStr.replace('s', '')) || 120;
      
      // 设置倒计时（记录开始时间，用实际时间差来计算剩余秒数）
      this.waitingInitialTime = seconds; // 保存初始时间
      this.waitingStartTime = Date.now(); // 记录开始时间（毫秒）
      this.waitingCountdown = seconds;
      this.showWaitingModal = true;
      this.waitingResult = null;
      this.waitingRealProfit = null; // 重置真实盈亏
      this.waitingForceLose = false; // 重置强制亏损状态
      // 注意：不重置 waitingOrderId、waitingExpect、waitingLid，因为这些是在 submitAuth 中设置的
      
      // 清除之前的定时器
      if(this.waitingTimer) {
        clearInterval(this.waitingTimer);
      }
      if(this.waitingPriceTimer) {
        clearInterval(this.waitingPriceTimer);
      }
      if(this.waitingForceLoseTimer) {
        clearInterval(this.waitingForceLoseTimer);
      }
      
      // 先获取真实盈亏
      this.getRealProfit().then(() => {
        // 获取真实盈亏后，启动价格浮动（根据真实盈亏调整）
        this.startWaitingPriceFluctuation();
      }).catch(() => {
        // 如果获取失败，仍然启动价格浮动（使用默认逻辑）
        this.startWaitingPriceFluctuation();
      });
      
      // 启动定期检查 force_lose 状态（每3秒检查一次）
      this.startCheckingForceLose();
      
      // 启动倒计时：根据当前时间与开始时间的差值来更新，避免切出页面后计时不准
      this.waitingTimer = setInterval(() => {
        if (this.waitingStartTime && this.waitingInitialTime > 0) {
          const elapsed = Math.floor((Date.now() - this.waitingStartTime) / 1000); // 已经过的秒数
          const remain = this.waitingInitialTime - elapsed;
          this.waitingCountdown = remain > 0 ? remain : 0;
        } else {
          // 兜底：如果缺少开始时间信息，按旧逻辑每秒减 1
          this.waitingCountdown--;
        }
        
        if(this.waitingCountdown <= 0) {
          // 倒计时结束，获取结果
          clearInterval(this.waitingTimer);
          this.waitingTimer = null;
          // 停止价格浮动
          if(this.waitingPriceTimer) {
            clearInterval(this.waitingPriceTimer);
            this.waitingPriceTimer = null;
          }
          // 停止检查 force_lose
          if(this.waitingForceLoseTimer) {
            clearInterval(this.waitingForceLoseTimer);
            this.waitingForceLoseTimer = null;
          }
          this.getWaitingResult();
        }
      }, 1000);
    },
    // 获取真实盈亏
    getRealProfit() {
      return new Promise((resolve, reject) => {
        // 使用 user_get_game_list 接口获取订单列表，然后根据订单ID过滤
        this.$http({
          method: 'get',
          data: {
            page: 1,
            limit: 100, // 获取足够多的数据以便找到订单
            status: 0, // 获取所有状态的订单
            lottery_id: 'all' // 获取所有彩种的订单
          },
          url: 'user_get_game_list' // 获取订单列表的接口
        }).then(res => {
          console.log('获取订单列表接口响应:', res);
          if(res.code === 200 && res.data && Array.isArray(res.data)) {
            // 优先通过订单ID查找，如果没有订单ID，则通过期号和彩种ID查找
            let order = null;
            if(this.waitingOrderId) {
              order = res.data.find(item => item.id == this.waitingOrderId || item.order_id == this.waitingOrderId);
            }
            
            // 如果通过订单ID没找到，尝试通过期号和彩种ID查找
            if(!order && this.waitingExpect && this.waitingLid) {
              // 先尝试精确匹配期号
              order = res.data.find(item => {
                return item.expect == this.waitingExpect && item.lottery_id == this.waitingLid;
              });
              
              // 如果精确匹配没找到，查找最新的未结算订单（状态为0）且彩种ID匹配
              if(!order && this.waitingLid) {
                const matchingOrders = res.data.filter(item => {
                  return item.lottery_id == this.waitingLid && item.status === 0;
                });
                
                if(matchingOrders.length > 0) {
                  // 按ID降序排序，取最新的订单
                  matchingOrders.sort((a, b) => b.id - a.id);
                  order = matchingOrders[0];
                  console.log('通过彩种ID找到最新的未结算订单，订单ID:', order.id, '期号:', order.expect);
                }
              }
              
              // 如果找到了订单，更新 waitingOrderId 和 waitingExpect
              if(order) {
                this.waitingOrderId = order.id;
                if(order.expect) {
                  this.waitingExpect = order.expect;
                }
                console.log('找到订单，更新 waitingOrderId:', this.waitingOrderId, 'waitingExpect:', this.waitingExpect);
              }
            }
            
            if(order) {
              console.log('找到订单:', order);
              console.log('订单 data 数组:', order.data);
              
              // profit 字段在 data 数组的第一个元素中
              let orderDetail = null;
              if(order.data && Array.isArray(order.data) && order.data.length > 0) {
                orderDetail = order.data[0];
                console.log('订单详情（data[0]）:', orderDetail);
              }
              
              // 优先从 data[0] 中获取 profit，如果没有则从 order 本身获取
              const profit = (orderDetail && (orderDetail.profit || orderDetail.profit_amount || orderDetail.profitAmount)) ||
                            order.profit || order.profit_amount || order.profitAmount || null;
              
              // 检查 force_lose 字段（强制亏损）
              const forceLose = (orderDetail && (orderDetail.force_lose === 1 || orderDetail.force_lose === '1')) ||
                               (order.force_lose === 1 || order.force_lose === '1');
              
              // 保存 force_lose 状态（无论 profit 是否为 null）
              const forceLoseChanged = this.waitingForceLose !== forceLose;
              this.waitingForceLose = forceLose;
              console.log('保存 force_lose 状态:', this.waitingForceLose, forceLoseChanged ? '(状态变化)' : '');
              
              // 如果 force_lose 状态变化为 true，立即更新价格
              if(forceLoseChanged && forceLose) {
                console.log('检测到强制亏损，立即更新价格');
                // 使用 $nextTick 确保在下一个 DOM 更新周期更新价格
                this.$nextTick(() => {
                  this.updateWaitingPrice();
                });
              } else if(forceLose && this.waitingForceLose) {
                // 即使状态未变化，如果 force_lose 为 true，也要确保价格已更新
                console.log('force_lose 已为 true，检查价格是否需要更新');
                const currentPrice = parseFloat(this.waitingCurrentPrice) || 0;
                const buyPrice = parseFloat(this.waitingBuyPrice) || 0;
                
                // 如果当前价格高于购买价格，说明价格还没更新，需要立即更新
                if(currentPrice >= buyPrice) {
                  console.log('当前价格高于购买价格，立即更新为负数价格');
                  this.$nextTick(() => {
                    this.updateWaitingPrice();
                  });
                }
              }
              
              if(profit !== null && profit !== undefined && profit !== '') {
                let profitNum = parseFloat(profit);
                if(!isNaN(profitNum)) {
                  // 如果设置了强制亏损，将 profit 转换为负数
                  if(forceLose) {
                    console.log('检测到强制亏损（force_lose=1），将 profit 转换为负数');
                    // 如果 profit 是正数，转换为负数；如果已经是负数，保持不变
                    if(profitNum > 0) {
                      profitNum = -Math.abs(profitNum);
                      console.log('强制亏损：profit 从正数转换为负数:', profitNum);
                    }
                  }
                  
                  this.waitingRealProfit = profitNum;
                  console.log('✓ 保存的真实盈亏:', this.waitingRealProfit, forceLose ? '(强制亏损)' : '');
                  resolve();
                  return;
                }
              } else {
                console.warn('订单 profit 为 null，订单可能还未结算，订单数据:', order);
                // 如果 profit 为 null，但 force_lose 已设置，仍然 resolve（因为 force_lose 状态已保存）
                if(forceLose) {
                  console.log('profit 为 null，但 force_lose=1，已保存状态，继续等待 profit');
                  // 立即更新价格，使盈亏显示为负数
                  this.$nextTick(() => {
                    this.updateWaitingPrice();
                  });
                  // 即使 profit 为 null，也 resolve（因为 force_lose 状态已保存）
                  resolve();
                  return;
                }
                // 如果 profit 为 null 且 force_lose 也为 0，继续等待
                // 这里先不 reject，等待倒计时结束后再获取
              }
            } else {
              console.warn('未找到订单ID为', this.waitingOrderId, '的订单');
            }
          }
          
          console.warn('无法获取真实盈亏，使用默认值');
          reject();
        }).catch((err) => {
          console.error('获取真实盈亏失败:', err);
          reject();
        });
      });
    },
    // 启动等待界面的价格浮动
    startWaitingPriceFluctuation() {
      // 立即更新一次价格
      this.updateWaitingPrice();
      
      // 每1秒更新一次价格
      this.waitingPriceTimer = setInterval(() => {
        this.updateWaitingPrice();
      }, 1000);
    },
    // 启动定期检查 force_lose 状态
    startCheckingForceLose() {
      console.log('启动定期检查 force_lose 状态，订单ID:', this.waitingOrderId);
      // 立即检查一次
      this.checkForceLoseStatus();
      
      // 每3秒检查一次 force_lose 状态
      this.waitingForceLoseTimer = setInterval(() => {
        console.log('定时检查 force_lose 状态（每3秒）');
        this.checkForceLoseStatus();
      }, 3000);
      console.log('已启动 force_lose 状态检查定时器');
    },
    // 检查 force_lose 状态
    checkForceLoseStatus() {
      // 如果没有订单ID，尝试使用期号和彩种ID查找
      if(!this.waitingOrderId && (!this.waitingExpect || !this.waitingLid)) {
        console.warn('checkForceLoseStatus: waitingOrderId 为空，且没有 expect 或 lid，跳过检查');
        return;
      }
      
      console.log('开始检查 force_lose 状态，订单ID:', this.waitingOrderId, '期号:', this.waitingExpect, '彩种ID:', this.waitingLid, '当前状态:', this.waitingForceLose);
      
      this.$http({
        method: 'get',
        data: {
          page: 1,
          limit: 100,
          status: 0, // 获取所有状态的订单（包括未结算的）
          lottery_id: 'all'
        },
        url: 'user_get_game_list'
      }).then(res => {
        console.log('检查 force_lose 状态 - 接口响应:', res);
        if(res.code === 200 && res.data && Array.isArray(res.data)) {
          // 优先通过订单ID查找，如果没有订单ID，则通过期号和彩种ID查找
          let order = null;
          if(this.waitingOrderId) {
            order = res.data.find(item => item.id == this.waitingOrderId || item.order_id == this.waitingOrderId);
          }
          
          // 如果通过订单ID没找到，尝试通过期号和彩种ID查找
          if(!order && this.waitingExpect && this.waitingLid) {
            // 先尝试精确匹配期号
            order = res.data.find(item => {
              return item.expect == this.waitingExpect && item.lottery_id == this.waitingLid;
            });
            
            // 如果精确匹配没找到，查找最新的未结算订单（状态为0）且彩种ID匹配
            if(!order && this.waitingLid) {
              const matchingOrders = res.data.filter(item => {
                return item.lottery_id == this.waitingLid && item.status === 0;
              });
              
              if(matchingOrders.length > 0) {
                // 按ID降序排序，取最新的订单
                matchingOrders.sort((a, b) => b.id - a.id);
                order = matchingOrders[0];
                console.log('通过彩种ID找到最新的未结算订单，订单ID:', order.id, '期号:', order.expect);
              }
            }
            
            // 如果找到了订单，更新 waitingOrderId 和 waitingExpect
            if(order) {
              this.waitingOrderId = order.id;
              if(order.expect) {
                this.waitingExpect = order.expect;
              }
              console.log('找到订单，更新 waitingOrderId:', this.waitingOrderId, 'waitingExpect:', this.waitingExpect);
            }
          }
          
          if(order) {
            console.log('检查 force_lose 状态 - 找到订单:', order);
            // profit 字段在 data 数组的第一个元素中
            let orderDetail = null;
            if(order.data && Array.isArray(order.data) && order.data.length > 0) {
              orderDetail = order.data[0];
              console.log('检查 force_lose 状态 - 订单详情:', orderDetail);
            }
            
            // 检查 force_lose 字段（强制亏损）
            const forceLose = (orderDetail && (orderDetail.force_lose === 1 || orderDetail.force_lose === '1')) ||
                             (order.force_lose === 1 || order.force_lose === '1');
            
            console.log('检查 force_lose 状态 - 当前状态:', this.waitingForceLose, '新状态:', forceLose, 'orderDetail.force_lose:', orderDetail ? orderDetail.force_lose : 'N/A');
            
            // 如果 force_lose 状态发生变化，更新状态
            if(this.waitingForceLose !== forceLose) {
              console.log('✓ 检测到 force_lose 状态变化:', this.waitingForceLose, '->', forceLose);
              this.waitingForceLose = forceLose;
              
              // 如果新设置为强制亏损，同时更新真实盈亏（如果已获取）
              if(forceLose && this.waitingRealProfit !== null && this.waitingRealProfit !== undefined && this.waitingRealProfit > 0) {
                // 将正数转换为负数
                this.waitingRealProfit = -Math.abs(this.waitingRealProfit);
                console.log('强制亏损：更新 waitingRealProfit 为负数:', this.waitingRealProfit);
              }
              
              // 如果新设置为强制亏损，即使没有真实盈亏，也要触发界面更新
              if(forceLose) {
                console.log('强制亏损已设置，等待界面中的盈亏将显示为负数');
                // 立即更新价格，使盈亏显示为负数
                this.updateWaitingPrice();
                // 强制触发 Vue 的响应式更新
                this.$forceUpdate();
              }
            } else {
              console.log('force_lose 状态未变化，当前状态:', this.waitingForceLose);
              
              // 即使状态未变化，如果 force_lose 为 true，也要确保价格已更新
              if(forceLose && this.waitingForceLose) {
                console.log('force_lose 已为 true，检查价格是否需要更新');
                const currentPrice = parseFloat(this.waitingCurrentPrice) || 0;
                const buyPrice = parseFloat(this.waitingBuyPrice) || 0;
                
                // 如果当前价格高于购买价格，说明价格还没更新，需要立即更新
                if(currentPrice >= buyPrice) {
                  console.log('当前价格高于购买价格，立即更新为负数价格');
                  this.updateWaitingPrice();
                  this.$forceUpdate();
                }
              }
            }
          } else {
            console.warn('检查 force_lose 状态 - 未找到订单ID为', this.waitingOrderId, '的订单');
          }
        } else {
          console.warn('检查 force_lose 状态 - 接口返回数据格式错误:', res);
        }
      }).catch(err => {
        console.error('检查 force_lose 状态失败:', err);
      });
    },
    // 更新等待界面的当前价格（根据真实盈亏调整浮动，使其接近真实盈亏）
    updateWaitingPrice() {
      const buyPrice = parseFloat(this.waitingBuyPrice) || 0;
      
      if(buyPrice <= 0) {
        this.waitingCurrentPrice = '0.00';
        return;
      }
      
      // 如果设置了强制亏损，无论真实盈亏如何，都要生成低于购买价格的价格
      if(this.waitingForceLose) {
        // 如果有真实盈亏，在真实盈亏附近浮动（但确保价格低于购买价格）
        if(this.waitingRealProfit !== null && this.waitingRealProfit !== undefined) {
          // 目标价格 = 购买价格 + 真实盈亏（真实盈亏应该是负数）
          const targetPrice = buyPrice + this.waitingRealProfit;
          
          // 在目标价格附近浮动（±3%的波动范围）
          const fluctuationPercent = 0.03; // 3%的波动
          const fluctuationAmount = Math.abs(targetPrice) * fluctuationPercent;
          const minPrice = targetPrice - fluctuationAmount;
          const maxPrice = targetPrice + fluctuationAmount;
          
          // 在波动范围内生成随机价格
          const randomPrice = minPrice + Math.random() * (maxPrice - minPrice);
          
          // 确保价格低于购买价格（因为强制亏损）
          const finalPrice = Math.min(randomPrice, buyPrice - 0.01);
          this.waitingCurrentPrice = finalPrice.toFixed(2);
        } else {
          // 如果没有真实盈亏，生成一个低于购买价格的价格（在购买金额的 0.1% 到 2% 范围内）
          const minPercent = 0.001; // 0.1%
          const maxPercent = 0.02;  // 2%
          const percent = minPercent + Math.random() * (maxPercent - minPercent);
          const decrement = buyPrice * percent;
          const finalDecrement = Math.max(decrement, 0.01);
          const newPrice = buyPrice - finalDecrement;
          this.waitingCurrentPrice = newPrice.toFixed(2);
        }
        return;
      }
      
      // 如果没有设置强制亏损，按原来的逻辑处理
      // 如果有真实盈亏，根据真实盈亏调整浮动范围
      if(this.waitingRealProfit !== null && this.waitingRealProfit !== undefined) {
        // 目标价格 = 购买价格 + 真实盈亏
        const targetPrice = buyPrice + this.waitingRealProfit;
        
        // 在目标价格附近浮动（±3%的波动范围，使浮动更接近真实盈亏）
        const fluctuationPercent = 0.03; // 3%的波动
        const fluctuationAmount = Math.abs(targetPrice) * fluctuationPercent;
        const minPrice = targetPrice - fluctuationAmount;
        const maxPrice = targetPrice + fluctuationAmount;
        
        // 在波动范围内生成随机价格
        const randomPrice = minPrice + Math.random() * (maxPrice - minPrice);
        
        // 如果真实盈亏是正数，确保价格至少比购买价格高0.01
        // 如果真实盈亏是负数，允许价格低于购买价格（但不要低太多）
        let finalPrice = randomPrice;
        if(this.waitingRealProfit > 0) {
          finalPrice = Math.max(randomPrice, buyPrice + 0.01);
        } else {
          // 如果真实盈亏是负数，价格可以在购买价格附近，但不要低于购买价格太多
          finalPrice = Math.max(randomPrice, buyPrice + this.waitingRealProfit - Math.abs(this.waitingRealProfit) * 0.5);
        }
        
        this.waitingCurrentPrice = finalPrice.toFixed(2);
      } else {
        // 如果没有真实盈亏，使用默认的小范围浮动（总是盈利）
        // 增量范围：购买价格的 0.1% 到 2%（浮动区间较小）
        const minPercent = 0.001; // 0.1%
        const maxPercent = 0.02;  // 2%
        const percent = minPercent + Math.random() * (maxPercent - minPercent);
        const increment = buyPrice * percent;
        
        // 确保增量至少为 0.01
        const finalIncrement = Math.max(increment, 0.01);
        const newPrice = buyPrice + finalIncrement;
        this.waitingCurrentPrice = newPrice.toFixed(2);
      }
    },
    // 获取等待结果
    getWaitingResult() {
      // 停止价格浮动
      if(this.waitingPriceTimer) {
        clearInterval(this.waitingPriceTimer);
        this.waitingPriceTimer = null;
      }
      
      // 先尝试获取最新的真实盈亏
      this.getRealProfit().then(() => {
        // 获取到真实盈亏后，显示结果
        this.displayWaitingResult();
      }).catch(() => {
        // 如果获取失败，仍然显示结果（使用之前获取的真实盈亏或默认值）
        this.displayWaitingResult();
      });
    },
    // 显示等待结果
    displayWaitingResult() {
      // 使用 user_get_game_list 接口获取订单列表，然后根据订单ID过滤
      this.$http({
        method: 'get',
        data: {
          page: 1,
          limit: 100, // 获取足够多的数据以便找到订单
          status: 0, // 获取所有状态的订单（包括已结算的）
          lottery_id: 'all' // 获取所有彩种的订单
        },
        url: 'user_get_game_list' // 获取订单列表的接口
      }).then(res => {
        console.log('获取结果接口完整响应:', JSON.stringify(res, null, 2));
        console.log('res.data 类型:', typeof res.data, Array.isArray(res.data) ? '数组' : '对象');
        console.log('res.data 内容:', res.data);
        
        if(res.code === 200 && res.data && Array.isArray(res.data)) {
          // 优先通过订单ID查找，如果没有订单ID，则通过期号和彩种ID查找
          let order = null;
          if(this.waitingOrderId) {
            order = res.data.find(item => item.id == this.waitingOrderId || item.order_id == this.waitingOrderId);
          }
          
          // 如果通过订单ID没找到，尝试通过期号和彩种ID查找
          if(!order && this.waitingExpect && this.waitingLid) {
            order = res.data.find(item => {
              return item.expect == this.waitingExpect && item.lottery_id == this.waitingLid;
            });
            
            // 如果找到了订单，更新 waitingOrderId
            if(order) {
              this.waitingOrderId = order.id;
              console.log('通过期号和彩种ID找到订单，更新 waitingOrderId:', this.waitingOrderId);
            }
          }
          
          if(order) {
            console.log('找到订单:', order);
            console.log('订单 data 数组:', order.data);
            
            // profit 字段在 data 数组的第一个元素中
            let orderDetail = null;
            if(order.data && Array.isArray(order.data) && order.data.length > 0) {
              orderDetail = order.data[0];
              console.log('订单详情（data[0]）:', orderDetail);
            }
            
            // 优先从 data[0] 中获取 profit，如果没有则从 order 本身获取
            const backendProfit = (orderDetail && (orderDetail.profit || orderDetail.profit_amount || orderDetail.profitAmount)) ||
                                 order.profit || order.profit_amount || order.profitAmount || null;
            
            // 检查 force_lose 字段（强制亏损）
            const forceLose = (orderDetail && (orderDetail.force_lose === 1 || orderDetail.force_lose === '1')) ||
                             (order.force_lose === 1 || order.force_lose === '1');
            
            // 保存 force_lose 状态（无论 profit 是否为 null）
            this.waitingForceLose = forceLose;
            console.log('保存 force_lose 状态:', this.waitingForceLose);
            
            console.log('订单 profit 字段:', backendProfit, '类型:', typeof backendProfit);
            console.log('订单 force_lose 字段:', forceLose, 'orderDetail.force_lose:', orderDetail ? orderDetail.force_lose : 'N/A');
            console.log('订单 money 字段（下注金额）:', orderDetail ? orderDetail.money : order.money);
            console.log('提取的盈亏值:', backendProfit, '类型:', typeof backendProfit);
            
            // 优先使用接口返回的盈亏（无论是正数还是负数）
            let finalProfit = null;
            if(backendProfit !== null && backendProfit !== undefined && backendProfit !== '') {
              let profitNum = parseFloat(backendProfit);
              if(!isNaN(profitNum)) {
                // 如果设置了强制亏损，将 profit 转换为负数
                if(forceLose) {
                  console.log('检测到强制亏损（force_lose=1），将 profit 转换为负数');
                  // 如果 profit 是正数，转换为负数；如果已经是负数，保持不变
                  if(profitNum > 0) {
                    profitNum = -Math.abs(profitNum);
                    console.log('强制亏损：profit 从正数转换为负数:', profitNum);
                  }
                }
                
                // 保留处理后的正负号
                finalProfit = profitNum.toFixed(2);
                // 同时更新 waitingRealProfit（保留正负号）
                this.waitingRealProfit = profitNum;
                console.log('✓ 使用接口返回的盈亏（处理后）:', finalProfit, '类型:', profitNum > 0 ? '盈利' : profitNum < 0 ? '亏损' : '平', forceLose ? '(强制亏损)' : '');
              } else {
                console.warn('盈亏值无法转换为数字:', backendProfit);
              }
            } else {
              // 如果 profit 为 null，说明订单可能还未结算，需要轮询等待
              console.warn('订单 profit 为 null，开始轮询等待结算...');
              
              // 先显示一个初始结果（使用临时值）
              let tempProfit = this.waitingRealProfit !== null && this.waitingRealProfit !== undefined 
                ? this.waitingRealProfit.toFixed(2) 
                : this.getWaitingProfit();
              
              this.waitingResult = {
                isWin: order.is_win === 1 || order.is_win === '1' || order.status === 1,
                message: this.$t('game.resultPending') + '（结算中...）',
                profit: tempProfit
              };
              
              // 开始轮询，等待获取真实的 profit
              this.pollOrderProfit();
              return; // 提前返回
            }
            
            // 如果接口没有返回盈亏，使用之前获取的真实盈亏
            if(finalProfit === null) {
              if(this.waitingRealProfit !== null && this.waitingRealProfit !== undefined) {
                finalProfit = this.waitingRealProfit.toFixed(2);
                console.log('使用之前获取的真实盈亏:', finalProfit);
              } else {
                finalProfit = this.getWaitingProfit();
                console.log('使用计算的虚拟盈亏:', finalProfit);
              }
            }
            
            // 根据 profit 的正负和 force_lose 来判断 isWin
            const profitValue = parseFloat(finalProfit);
            
            // 如果设置了强制亏损，isWin 必须为 false
            let isWin = false;
            if(forceLose) {
              console.log('强制亏损：isWin 设置为 false');
              isWin = false;
            } else {
              // 优先从 data[0] 中获取 is_win，如果没有则从 order 本身获取
              const orderIsWin = (orderDetail && (orderDetail.is_win === 1 || orderDetail.is_win === '1')) || 
                                (order.is_win === 1 || order.is_win === '1');
              // 根据 profit 的正负来判断，如果 profit 有效则优先使用 profit
              isWin = !isNaN(profitValue) ? profitValue > 0 : (orderIsWin || order.status === 1);
            }
            
            console.log('最终判断 - isWin:', isWin, 'profit:', finalProfit, 'force_lose:', forceLose);
            
            this.waitingResult = {
              isWin: isWin,
              message: (orderDetail && orderDetail.message) || order.message || res.msg || '',
              profit: finalProfit
            };
            
            console.log('最终显示的结果:', this.waitingResult);
            console.log('profit 值:', finalProfit, 'isWin:', isWin, 'profit > 0:', profitValue > 0);
          } else {
            console.warn('未找到订单ID为', this.waitingOrderId, '的订单');
            // 如果找不到订单，使用之前获取的真实盈亏
            let finalProfit = null;
            if(this.waitingRealProfit !== null && this.waitingRealProfit !== undefined) {
              finalProfit = this.waitingRealProfit.toFixed(2);
              console.log('未找到订单，使用之前获取的真实盈亏:', finalProfit);
            } else {
              finalProfit = this.getWaitingProfit();
              console.log('未找到订单，使用计算的虚拟盈亏:', finalProfit);
            }
            
            this.waitingResult = {
              isWin: parseFloat(finalProfit) > 0,
              message: res.msg || this.$t('game.resultPending'),
              profit: finalProfit
            };
          }
        } else {
          console.warn('接口返回失败或数据为空:', res);
          // 如果接口返回失败，使用真实盈亏
          let finalProfit = null;
          if(this.waitingRealProfit !== null && this.waitingRealProfit !== undefined) {
            finalProfit = this.waitingRealProfit.toFixed(2);
            console.log('接口失败，使用之前获取的真实盈亏:', finalProfit);
          } else {
            finalProfit = this.getWaitingProfit();
            console.log('接口失败，使用计算的虚拟盈亏:', finalProfit);
          }
          
          this.waitingResult = {
            isWin: parseFloat(finalProfit) > 0, // 根据盈亏判断
            message: res.msg || this.$t('game.resultPending'),
            profit: finalProfit
          };
        }
        // 不自动关闭，让用户手动关闭
      }).catch(err => {
        console.error('获取结果失败:', err);
        console.error('错误详情:', err.response || err);
        // 如果接口不存在，使用真实盈亏
        let finalProfit = null;
        if(this.waitingRealProfit !== null && this.waitingRealProfit !== undefined) {
          finalProfit = this.waitingRealProfit.toFixed(2);
          console.log('接口异常，使用之前获取的真实盈亏:', finalProfit);
        } else {
          finalProfit = this.getWaitingProfit();
          console.log('接口异常，使用计算的虚拟盈亏:', finalProfit);
        }
        
        this.waitingResult = {
          isWin: parseFloat(finalProfit) > 0, // 根据盈亏判断
          message: this.$t('game.resultPending') + '（結果はタスク記録で確認できます）',
          profit: finalProfit
        };
        // 不自动关闭，让用户手动关闭
      });
    },
    // 轮询订单，等待结算后获取 profit
    pollOrderProfit() {
      let pollCount = 0;
      const maxPollCount = 20; // 最多轮询20次
      const pollInterval = 1000; // 每1秒轮询一次
      
      const poll = () => {
        pollCount++;
        console.log(`轮询订单 profit（第 ${pollCount} 次）...`);
        
        this.$http({
          method: 'get',
          data: {
            page: 1,
            limit: 100,
            status: 0,
            lottery_id: 'all'
          },
          url: 'user_get_game_list'
        }).then(res => {
          if(res.code === 200 && res.data && Array.isArray(res.data)) {
            // 优先通过订单ID查找，如果没有订单ID，则通过期号和彩种ID查找
            let order = null;
            if(this.waitingOrderId) {
              order = res.data.find(item => item.id == this.waitingOrderId || item.order_id == this.waitingOrderId);
            }
            
            // 如果通过订单ID没找到，尝试通过期号和彩种ID查找
            if(!order && this.waitingExpect && this.waitingLid) {
              order = res.data.find(item => {
                return item.expect == this.waitingExpect && item.lottery_id == this.waitingLid;
              });
              
              // 如果找到了订单，更新 waitingOrderId
              if(order) {
                this.waitingOrderId = order.id;
                console.log(`轮询第 ${pollCount} 次 - 通过期号和彩种ID找到订单，更新 waitingOrderId:`, this.waitingOrderId);
              }
            }
            
            if(order) {
              // profit 字段在 data 数组的第一个元素中
              let orderDetail = null;
              if(order.data && Array.isArray(order.data) && order.data.length > 0) {
                orderDetail = order.data[0];
              }
              
              console.log(`轮询第 ${pollCount} 次 - 订单详情:`, orderDetail);
              
              // 优先从 data[0] 中获取 profit，如果没有则从 order 本身获取
              const profit = (orderDetail && (orderDetail.profit || orderDetail.profit_amount || orderDetail.profitAmount)) ||
                            order.profit || order.profit_amount || order.profitAmount || null;
              
              // 检查 force_lose 字段（强制亏损）
              const forceLose = (orderDetail && (orderDetail.force_lose === 1 || orderDetail.force_lose === '1')) ||
                               (order.force_lose === 1 || order.force_lose === '1');
              
              // 保存 force_lose 状态（无论 profit 是否为 null）
              this.waitingForceLose = forceLose;
              
              console.log(`轮询第 ${pollCount} 次 - profit:`, profit, 'force_lose:', forceLose, 'orderDetail.force_lose:', orderDetail ? orderDetail.force_lose : 'N/A');
              console.log(`轮询第 ${pollCount} 次 - 保存 force_lose 状态:`, this.waitingForceLose);
              
              if(profit !== null && profit !== undefined && profit !== '') {
                let profitNum = parseFloat(profit);
                if(!isNaN(profitNum)) {
                  // 如果设置了强制亏损，将 profit 转换为负数
                  if(forceLose) {
                    console.log('轮询检测到强制亏损（force_lose=1），将 profit 转换为负数');
                    // 如果 profit 是正数，转换为负数；如果已经是负数，保持不变
                    if(profitNum > 0) {
                      profitNum = -Math.abs(profitNum);
                      console.log('强制亏损：profit 从正数转换为负数:', profitNum);
                    }
                  }
                  
                  // 获取到 profit 了，更新显示（保留处理后的正负号）
                  this.waitingRealProfit = profitNum;
                  const finalProfit = profitNum.toFixed(2);
                  
                  console.log('✓ 轮询获取到 profit（处理后）:', finalProfit, '类型:', profitNum > 0 ? '盈利' : profitNum < 0 ? '亏损' : '平', forceLose ? '(强制亏损)' : '');
                  
                  // 更新结果显示（如果强制亏损，isWin 必须为 false）
                  const isWin = forceLose ? false : (profitNum > 0);
                  if(this.waitingResult) {
                    this.waitingResult.profit = finalProfit;
                    this.waitingResult.isWin = isWin;
                    this.waitingResult.message = isWin ? this.$t('game.win') : this.$t('game.lose');
                  } else {
                    this.waitingResult = {
                      isWin: isWin,
                      message: isWin ? this.$t('game.win') : this.$t('game.lose'),
                      profit: finalProfit
                    };
                  }
                  console.log('更新结果显示 - profit:', finalProfit, 'isWin:', isWin, 'force_lose:', forceLose);
                  return; // 停止轮询
                } else {
                  console.warn(`轮询第 ${pollCount} 次 - profit 值无法转换为数字:`, profit);
                }
              } else {
                console.warn(`轮询第 ${pollCount} 次 - profit 为 null 或 undefined，继续等待结算...`);
                // 即使 profit 为 null，如果 force_lose 已设置，也要保存状态
                if(forceLose) {
                  console.log(`轮询第 ${pollCount} 次 - profit 为 null，但 force_lose=1，已保存状态`);
                }
              }
            } else {
              console.warn(`轮询第 ${pollCount} 次 - 未找到订单ID为`, this.waitingOrderId, '的订单');
            }
          } else {
            console.warn(`轮询第 ${pollCount} 次 - 接口返回数据格式错误:`, res);
          }
          
          // 如果还没获取到 profit，继续轮询
          if(pollCount < maxPollCount) {
            setTimeout(poll, pollInterval);
          } else {
            console.warn('轮询超时，未获取到 profit，使用默认值');
            // 轮询超时，使用默认值
            const finalProfit = this.waitingRealProfit !== null && this.waitingRealProfit !== undefined 
              ? this.waitingRealProfit.toFixed(2) 
              : this.getWaitingProfit();
            
            if(this.waitingResult) {
              this.waitingResult.profit = finalProfit;
            } else {
              this.waitingResult = {
                isWin: parseFloat(finalProfit) > 0,
                message: this.$t('game.resultPending'),
                profit: finalProfit
              };
            }
          }
        }).catch(err => {
          console.error('轮询订单失败:', err);
          // 轮询失败，使用默认值
          if(pollCount < maxPollCount) {
            setTimeout(poll, pollInterval);
          } else {
            const finalProfit = this.waitingRealProfit !== null && this.waitingRealProfit !== undefined 
              ? this.waitingRealProfit.toFixed(2) 
              : this.getWaitingProfit();
            
            if(this.waitingResult) {
              this.waitingResult.profit = finalProfit;
            } else {
              this.waitingResult = {
                isWin: parseFloat(finalProfit) > 0,
                message: this.$t('game.resultPending'),
                profit: finalProfit
              };
            }
          }
        });
      };
      
      // 开始轮询
      setTimeout(poll, pollInterval);
    },
    // 计算等待界面的盈亏（根据真实盈亏调整，使其接近真实盈亏）
    getWaitingProfit() {
      const currentPrice = parseFloat(this.waitingCurrentPrice) || 0;
      const buyPrice = parseFloat(this.waitingBuyPrice) || 0;
      let profit = currentPrice - buyPrice;
      
      // 如果设置了强制亏损，无论真实盈亏如何，都要显示为负数
      if(this.waitingForceLose) {
        // 如果有真实盈亏，在真实盈亏附近浮动（但确保是负数）
        if(this.waitingRealProfit !== null && this.waitingRealProfit !== undefined) {
          const targetProfit = Math.abs(this.waitingRealProfit); // 取绝对值作为目标
          const fluctuation = targetProfit * 0.2; // 20%的波动
          profit = -(targetProfit - fluctuation + Math.random() * (fluctuation * 2));
          // 确保是负数
          profit = -Math.abs(profit);
        } else {
          // 如果没有真实盈亏，生成一个负数（在购买金额的 0.1% 到 2% 范围内）
          const minPercent = 0.001; // 0.1%
          const maxPercent = 0.02;  // 2%
          const percent = minPercent + Math.random() * (maxPercent - minPercent);
          profit = -(buyPrice * percent);
        }
        return profit.toFixed(2);
      }
      
      // 如果没有设置强制亏损，按原来的逻辑处理
      // 如果有真实盈亏，调整虚拟盈亏使其接近真实盈亏
      if(this.waitingRealProfit !== null && this.waitingRealProfit !== undefined) {
        // 如果真实盈亏是正数，确保虚拟盈亏也是正数（但接近真实盈亏）
        // 如果真实盈亏是负数，允许虚拟盈亏也是负数（但接近真实盈亏）
        if(this.waitingRealProfit > 0) {
          // 真实盈亏是正数，虚拟盈亏也应该在真实盈亏附近（±20%）
          const targetProfit = this.waitingRealProfit;
          const fluctuation = targetProfit * 0.2; // 20%的波动
          profit = targetProfit - fluctuation + Math.random() * (fluctuation * 2);
          // 确保至少是正数
          profit = Math.max(profit, 0.01);
        } else {
          // 真实盈亏是负数，虚拟盈亏也应该在真实盈亏附近（±20%）
          const targetProfit = this.waitingRealProfit;
          const fluctuation = Math.abs(targetProfit) * 0.2; // 20%的波动
          profit = targetProfit - fluctuation + Math.random() * (fluctuation * 2);
        }
      } else {
        // 如果没有真实盈亏，确保总是显示为盈利（正数）
        if(profit <= 0) {
          profit = 0.01; // 最小盈利值
        }
      }
      
      return profit.toFixed(2);
    },
    // 获取盈亏的样式类
    getWaitingProfitClass() {
      const profit = parseFloat(this.getWaitingProfit()) || 0;
      if(profit > 0) {
        return 'profit-positive';
      } else if(profit < 0) {
        return 'profit-negative';
      } else {
        return '';
      }
    },
    // 获取结果显示时的盈亏样式类
    getResultProfitClass() {
      const profit = parseFloat(this.waitingResult?.profit || 0);
      if(profit > 0) {
        return 'profit-positive';
      } else if(profit < 0) {
        return 'profit-negative';
      } else {
        return '';
      }
    },
    // 关闭等待弹窗
    closeWaitingModal() {
      this.showWaitingModal = false;
      this.waitingCountdown = 0;
      this.waitingResult = null;
      this.waitingOrderId = null;
      this.waitingExpect = null;
      // 跳转到Mine界面
      this.$router.push({path:'/Mine'});
      this.waitingLid = null;
      
      // 停止倒计时定时器
      if(this.waitingTimer) {
        clearInterval(this.waitingTimer);
        this.waitingTimer = null;
      }
      
      // 停止价格更新定时器
      if(this.waitingPriceTimer) {
        clearInterval(this.waitingPriceTimer);
        this.waitingPriceTimer = null;
      }
      
      // 停止检查 force_lose 定时器
      if(this.waitingForceLoseTimer) {
        clearInterval(this.waitingForceLoseTimer);
        this.waitingForceLoseTimer = null;
      }
      
      // 重置等待界面相关数据
      this.waitingBuyPrice = '0.00';
      this.waitingCurrentPrice = '0.00';
      this.waitingInitialTime = 0;
      this.waitingRealProfit = null; // 重置真实盈亏
      this.waitingForceLose = false; // 重置强制亏损状态
      
      // 重置认证数据
      this.authAmount = '';
      this.authDuration = '120s';
      this.currentPrice = '0.00';
      this.estimatedProfit = '0.00';
    },
    check(){
      if(!localStorage.getItem('token')){
        this.$router.push({path:'/Login'})
      }else {
        time = window.setInterval(() => {
          setTimeout(()=>{
            this.getUserInfo();
            this.getLotteryInfo();
            this.getLotteryList();
            count++;
            if(count > 5){
              clearInterval(time);
              count = 0;
            }
          },0)
        }, 300)
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t('common.refresh'));
        this.getLotteryList();
        this.isLoading = false;
      }, 200);
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getLotteryPeilv(){
      this.$http({
        method: 'get',
        data:{id:this.$route.query.id},
        url: 'lottery_get_peilv'
      }).then(res=>{
        if(res.code === 200){
          this.lottery_peilv_list = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
	getGameItem(){
	  this.$http({
	    method: 'get',
	    url: 'lottery_hot'
	  }).then(res=>{
	    this.game_type_list = res.data;
	    // 设置当前游戏的标题和图片
	    if (this.$route.query.key && this.$route.query.id) {
	      this.updateGameInfo(this.$route.query.key, this.$route.query.id);
	    }
	  })
	},
    getLotteryList(){
      this.$http({
        method: 'get',
        data:{key:this.$route.query.key},
        url: 'lottery_get_one_list'
      }).then(res=>{
        if(res.code === 200){
          this.lottery_list = res.data;
          this.getLotteryPeilv();
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getLotteryInfo(){
      this.$http({
        method: 'get',
        data:{key:this.$route.query.key},
        url: 'lottery_get_info'
      }).then(res=>{
        if(res.code === 200){
          if(parseFloat(this.userInfo.money) < parseFloat(res.data.condition)){
            this.$toast(this.$t('game.lxgly'));
            this.$router.push({path:'/Home'})
            return false;
          }
          this.lottery = res.data;

		  // 强制更新标题和图片
		  this.showimage = res.data.ico;
		  this.showtitle = res.data.name;
		  
          // 获取价格区间配置
          if(res.data.price_min !== undefined && res.data.price_min !== null) {
            this.priceMin = parseFloat(res.data.price_min);
          }
          if(res.data.price_max !== undefined && res.data.price_max !== null) {
            this.priceMax = parseFloat(res.data.price_max);
          }
		  
          this.time = res.data.second * 1000;

          if(this.time/1000 === 59){
            this.$toast(this.$t('game.kjcc')+this.lottery.now_expect);
          }
          this.shanzi_1 = "img/lottery/shaizi/" + res.data?.opencode[0] + ".png";
          this.shanzi_2 = "img/lottery/shaizi/" + res.data?.opencode[1] + ".png";
          this.shanzi_3 = "img/lottery/shaizi/" + res.data?.opencode[2] + ".png";
          this.sum = res.data.opencode[0] + res.data.opencode[1] + res.data.opencode[2];
          if(this.sum >= 11 && this.sum <=18){
            this.size = this.$t('game.da');
          }else if(this.sum >= 3 && this.sum <= 10){
            this.size = this.$t('game.xiao');
          }
          if(this.sum % 2 === 0){
            this.double = this.$t('game.shuang');
          }else {
            this.double = this.$t('game.dan');
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })

    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
        this.getUserInfo();
        this.getGameItem();
        this.getLotteryInfo();
        this.getLotteryList();
        // 获取货币行情
        this.getCurrencyQuotes();
    }
  },
  destroyed() {
    clearInterval(time);
    // 清除价格更新定时器
    if(this.priceUpdateTimer) {
      clearInterval(this.priceUpdateTimer);
      this.priceUpdateTimer = null;
    }
    // 清除行情更新定时器
    this.stopQuoteUpdate();
    // 清除等待倒计时定时器
    if(this.waitingTimer) {
      clearInterval(this.waitingTimer);
      this.waitingTimer = null;
    }
    // 清除等待界面价格更新定时器
    if(this.waitingPriceTimer) {
      clearInterval(this.waitingPriceTimer);
      this.waitingPriceTimer = null;
    }
    // 清除检查 force_lose 定时器
    if(this.waitingForceLoseTimer) {
      clearInterval(this.waitingForceLoseTimer);
      this.waitingForceLoseTimer = null;
    }
  },
  beforeDestroy() {
    // 清除价格更新定时器
    if(this.priceUpdateTimer) {
      clearInterval(this.priceUpdateTimer);
      this.priceUpdateTimer = null;
    }
    // 清除行情更新定时器
    this.stopQuoteUpdate();
    // 清除等待倒计时定时器
    if(this.waitingTimer) {
      clearInterval(this.waitingTimer);
      this.waitingTimer = null;
    }
    // 清除等待界面价格更新定时器
    if(this.waitingPriceTimer) {
      clearInterval(this.waitingPriceTimer);
      this.waitingPriceTimer = null;
    }
    // 清除检查 force_lose 定时器
    if(this.waitingForceLoseTimer) {
      clearInterval(this.waitingForceLoseTimer);
      this.waitingForceLoseTimer = null;
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/basenew.css";
:export {
    gbcolor: linear-gradient(30deg,#7d76ef,#d63f8c)
}
.van-nav-bar {
    /* background: none; */
    position: relative;
    /* width: 100%; */
}
.lottery {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    background: url(/img/233.ebf5fe94.png) no-repeat top/100%;
    position: absolute
}

.lottery .van-nav-bar {
    background: linear-gradient(90deg,rgba(223,53,173,.8),rgba(79,29,181,.8))
}

.lottery .van-hairline--bottom:after {
    border: none
}

.lottery .van-nav-bar__text {
    color: #fff
}

.lottery .order {
    width: 80%;
    border-radius: .33333rem
}

.lottery .order .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: .5rem 5%;
    border-bottom: 1px solid #f7f8f9;
    background: linear-gradient(20deg,#a253d0,#d63f8c)
}

.lottery .order .title span {
    color: #fff;
    font-size: 1.03333rem
}

.lottery .order .title i {
    font-size: 1.33333rem;
    color: #fff
}

.lottery .order .content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: .66667rem 5%;
    border-bottom: 1px solid #f7f8f9
}

.lottery .order .content>div {
    text-align: left
}

.lottery .order .content>div span {
    color: #f6379c;
    font-size: .8rem;
    text-align: left;
    display: inline-block;
    padding: .33333rem 0
}

.lottery .order .content>div p {
    color: #5739ab;
    font-size: .86667rem
}

.lottery .order .content>span {
    display: flex;
    width: 1.2rem;
    height: 1.33333rem;
    background: #f6379c;
    border-radius: .2rem;
    position: relative
}

.lottery .order .content>span:before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 90%;
    height: .13333rem;
    background: #fff;
    margin: auto
}

.lottery .order .btn {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 50% 5% 5%
}

.lottery .order .btn a {
    border: 1px solid #979799;
    color: #979799;
    font-size: .8rem;
    padding: .53333rem 1.66667rem;
    border-radius: 3.33333rem
}

.lottery .order .btn a:last-child {
    background: linear-gradient(30deg,#7d76ef,#d63f8c);
    color: #fff;
    border: none
}

.lottery .mask {
    position: absolute;
    bottom: 0;
    min-height: 9rem;
    width: 100%;
    background: #fff;
    box-shadow: 0 -.13333rem .13333rem rgba(0,0,0,.07);
    padding: 0 3%
}

.lottery .mask .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: .33333rem 0
}

.lottery .mask .title p {
    color: #3b3597
}

.lottery .mask .title span {
    color: #ed37ae;
    font-size: .86667rem
}

.lottery .mask .title>div i {
    color: #ff253f;
    font-size: .86667rem
}

.lottery .mask .title>div i:first-child {
    position: relative;
    left: .6rem
}

.lottery .mask .c1 {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: .33333rem 0;
    color: #3b3597
}

.lottery .mask .c1 input {
    text-align: center;
    border: 0;
    background: #f2f2f5;
    padding: .33333rem 0;
    margin: 0 .33333rem;
    width: 8.33333rem
}

.lottery .mask .c1 span {
    min-width: 6.66667rem
}

.lottery .mask .c2 {
    border-top: 1px solid #f7f8f9;
    padding: .33333rem 0;
    margin-top: 0
}

.lottery .mask .c2 p {
    text-align: left;
    color: #3d359c
}

.lottery .mask .c2 p span {
    color: #ed50b2;
    padding: 0 .33333rem
}

.lottery .mask .c2 .cm {
    display: flex;
    justify-content: space-between;
    padding: .66667rem 0
}

.lottery .mask .c2 .cm>div {
    width: 16.666%;
    height: 2.6rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #a063ee;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAABPCAYAAAC9FghPAAAACXBIWXMAAAsTAAALEwEAmpwYAAANvklEQVR4nO2ceXTUVZbHP7eydCIiCVvGoRMIghAiBEEHHXEZbRUdVHYMBFoQAUNYpe3Tpwfn9PScPqebYWnADYEWyCKNbA49Aj3KTA+iIEGSAEGhQQiyKKssYUnqzh/vV5VXlaoklaWCzHzPeUn97nvvvnvv722/97v3J6qKP758Pq8SrQHR20lJwBZgE3AqnAL4IzIQsbKZGgR3A28CvSzay87/GcA84PvwiOILV2CyNHTqB5IP0itI/q9BCqrIb9AkgYZPQ6I4/b3pwEyLdB2YBRwBngD6+VV5OiXv+Q9DbKMuIobXKMXpK14DfmWRDgADUvKGFlll+gLvAU2scn1T8ob+KYR26iRnkOFT/9ibvmKSwq8UM2cpbFDoaRsEICVv6HqFXgolVtn1e9NX9K5pW1rHFJaesif9jy8CiyzS6tS8IQOrqdMS2AG0dUiXgQdT84bsrEF7tRUVCENP2ZO+8mmQRdZE9nF1BgFIzRtyCuQhkAtOvVtAVuxJX3lL9a3WbaJtUKPsHrYySYUcFXDSNhV+UtP6qXmDj6jwExWuOfU7qPCb6upZ7dUqNahRFJmpSJwiKHJakT535Q4OabzelTt4uyJDHR4oMrlo2PvDqmm3TinonFI47P2mmJ1mDHAJuOD8PweUdMsdVKVyhcPeHwu8bZEe7JY7aEuNrVGZ3zvAGOfSDaR1yx20O0hZ+7ItEA/cAjR1/l/B7J4vBKpfySgFw1e1w+wsX61Gzu3AfiDfaWBnWs7AcofHvU6+B79Oyxn4WjX8qkXB8FVfUzHxLk/LGTjSL78z5kZ2A7oCdwCJVbCchdlV/9Um+hhl1/DVDwD/AdxWS7k/BRYDDwCjHNrW7jkDHqglPx/sGr66G1BgkdKBCOAhzKavdS3YXgKeBD7xEPyMsqYQY2EPPsR0tSaYrtcEiMNYX2rY6J3dc/rvr4WwAbFr+JrfUn0vtnEYOItZ0i84/2OAp6wyRZjeBVgPhF9krBmAeA1yHnj67uz+W/1b+CJjTRMgAWgJdAR6Yu5Ud8xdszH77uz6MwiACr8AhlIxjGx8BfwFKMQoehT45u7s/qX+Bb/IWNML2Ag0w3SEDCAbrJ6yM2PtVuB+p860Htn95oQi7M6MtUnAo5gu/QRQCjTrkd3veih8atjWPwAfO5ebgT9ijFHcI7tfjVe3nRlrxwFvOZc7gHvBMUp+xroIoMzJLAcSe2Y/d7y2QudnrPt7oLxn9nPbasujBm2MBYp6Zj/3aR14xAPHMMMJzPRwWVSVHSM+GACscjL+cs/yZx+uk8Q/IOwY8cFGTM8GGAbkuQAU6W1tXtY2loCNAUXWWbr3VsRMtApPW+W2B6l/U0LBfsB8HCDys5HrWyHSySF+h99G5maHW+QgcBKzonYEElyKpFjdp/i+ZX1PNK6Y4cV9y/p+q8g+ywadXYp0tAj1uqf4oUCRA5YNOkSqSHMr/0yjSdaIUBFb7+aRitxqES6GW6AbAYrYet8aqUgzi3A+3ALdCFDkrHUZH6ki9vHe5XALdCNARa5YlzGRbuSqRfhRuAW6EeBGbL2vRqr8v1FU/I2ClFmEgO+Wb3YoYutdFqnmzNWDuPCKc2NAffU+F6kixRYhJczy3BBQEVvvYpcbOeBGcFKHTaM3/5+aVzaN3vwjN9LBssEBl4ocVBGc1F5Fqjr9vumgIomO3h4bHHQ9ufiRUkXynX1/rCKpjS1oOKFIqqM3jh1KzSGTyHuWpR5vbEHDCRV53NL9PRXnkMmN/NkqV+N3vTcD3Iit75/BOs1fP2bLt0ArJ7Nz30W9vwyveOHH+jFbOgH7nMvvcF6meV+wq8gHVjfq0wgyhh0q0sfS2at/hVGQDdZBywuNKGvYoMgLls5e/X1em64d+9kFwHO+ktZv4X2FjSJtGLB27Gf2e+mLmNfCgJ9/iiLLLMv5vNG/2aDISEtXW28/o4gss8bYqNXjtt+Uu9vV47bHqMgoS1dbb1+jDHj777YpstexWHNFftZYgjckFPmlox+OvtuC9hQAN/Ka9Rzw6spxO5oGYvxDxcpxO5q7kVctHWdYv3EHMsrgt+9ZpSIFTldqqiIzGkP4hoKK/EZFoh39tqvIanvoVBo+3orIDKs7TVsxfmf7cAvfEFgxfuddioyzdPvnQI6AAY0y9K0e/64inzqWi1CR3HAr0BBQkeVWj3hLRTb495KgPQXAjUyzxlmv3Jd3TQqnAvWN3Jd3TXEj3S2d3vSfSzypSjf0nMwCf/fxe4a/kZbf4BrUM3IyC3piPJU8GIHjyhUI1frmZ2cWfIRx2wL4FuiS8Uba6TrKGTZkZxa0APZS4Tn5nzguF8FQrce1IpmKXHUmodaKfLI8szCh7uI2PJZnFiYo8okjN44eWbX2uLaxdELRk8AGi3QUePSnr3e9Yb0Ulk4o6ohxFvyxRe6D8YisEjUObXl3wu6BgO3ffQp47IXX77rhHhrfnbC7G/ARxq3Vg0FU+PVViZDiff6QtacPxuHYg1Jg5KgFqe8HqRJ2/CFrzyBgGRBrkZ/Ct6dXiZCDoJZk7X0Ecxfs+Wjm6AVdQvGCbhAsydo7E5hukdzAY8B/hcInoFEWZxVXor24IMXOvxdzNzpbRQqAX7y4ICWkIMj6wOKs4nTgn4AuFnkfMBL4PFR+XqMsmrivmqI+aA5cBd5wGraRCywdM7/zplCFCRWLJu4bCkwAHvTLWgq8BLTA+OVfJQSIqvLOxFqdUUcBz2D88RdjnVw5+BxYAax9aX6nevO4fGfil3cA/TEbsG5+2bsd+nngUG3bEFVl4cSvfIiXSv6mK3A7JurhHHCiSeKJs5WrAxAN/BR4FugbIL8M4ze/EdOli4Bvxs6/8xrAwolfRYydf2e5p7B9vXDiV9FAG0xAQWdMCMpD+HpHXMSsKq9jYo/cwZTtyLVmIiSIaAugqYge31ceU+RfTt60DFJ6JCEWeBcY4lfuIiZEpNBJW4EvYpNO2pFVLoyT8vPAQCr83f2hmH1OPmZZnzp+Xkevz9lbk/bfCszBLKc9MfsM/zCa6xgjLwXWY8JvfJBcVh4taE8R7hPR7gJpItpORJsJIKKGqejbe92x4+26kX7T7MsBDALmMDvVSekO7ZvSIwkbgQ8RNsUknvzeEXA9JiD7SUww1PN+vAQTL+R5Z51lZ6pReAyVoZhApVwnVfLPS7xKlIj2cYk+pcgTCHeAmmhJcTT1/Hb+i8q4VFdp/m537DuWUXxuQo8AwgRDG2A0MBrl2JWShMWCLoxO/O4oJoxuP7AAeAXTa+7HbKD6WTwO49cLFBGH7onn2Q38DmPsgEO4TanEi+gYFR0nKncoVCju/Q1ChUHUoSGA8qgiXqO4VKSl5xwBWBmCUWz8LTBD4ctrJa3mXj/aKsE6nzjmeDbkZM7r0F9FxP/8wscolc83umbO67BcRc765yVcioi5/bLrXxTZpyq/U8cgCqiKNyLdGEd86OaPeG7ECp/zFEWueB6EotqeWgcMd+7OaUx8Xc1gGrkFmKxKUVlJy9H+D1oLJh8M+ADmy6ZyfqB6rS9EDEalSFVmqNLao7x6kmMAvL8tQymXFTmtsFtVhhfRZK3NOzLr9+0vzp98KB6na0a2PZ0L5JYdbtECE64a5/SEJOBhzHdPuhAIau60oK1UWVxe0vwRgQmSeDZgqGtgFlWHJrY6H3mroLNV9CW15wnA/1pEUShGZRfC/4AeRuUYwhnQS3ukScAjEO/mbd6Umi/r5V+3eBgzN/QnUCyfmM5qRobuFxhE0ln7wdEzvx8GOk+am+xdPeZNORSDWbrbVnAzaHkm6k4R/UBEO4mACzWriJNcjiFE9ISIrnHBKhH9+EBMVEjPMt7nl0lzk6nptwAi2p3574h2Z6Zi9g4v4Rsz49Xa2Fs6Ajsoie8dnKeNwGXiT0d3UfhcVTqZIWLNHRXDpEAhU1U6HoqNyvxrbNRHB2KiNdRvHfi4iE6a2877+/dTDldv0XZnr2COKxe5v44fjVklWphZ3Uzran5HierHUhKX6E48f7IqnoGGT9yp6BRFtyrcZpZWMUMVPEvtaVX5eUlT1+Jqha4BgvrNTp4bKMIV5k49EpAuyeeW6KG4DcBvgQxrfvGMlSiU7Oo8pfxXo2YnoxNUdLMIzdQxhmfhdq6zgZ+XxMmxqviGgpCdiafMSfL+nuNvoORzx4ARHIrbjAltjXKO90AERR9zHbkttjwp+Pen/Ae/wjMgCepZRwXPULkOOv54c5bUPG68ZqjTVzGmzkli6pykysto8vklwP1oRaiMM78ISnxIS7LKcfzmD4WLCvcfb84S//IB5Qkx1Yvb+bQ5Zsc+a1pJhXLtz+e7DjZ7AOVPKvJjMfPL8rLkC3Y3d2PioCvqCdeoiJEG2Kgq64G+znxyFOUfT7Ry+xyDvjI70eZRJ9Tr91OMYBWzuLv994VAd5RRijxbnnxhpN9MH/vK7ES/CHeJAGnpKXPu9utlZ2+//owig1RllCrdv2vtLrT52AZxeNQpNcg3mf5t2jfVFVHr/4jps9vkWHV/Cfyrc/k1kFwVo+mz29Sm/SrRYB+qmlm1YFswT9AevAtsw3wd8AWLPoQqnsd+FsAgNWi7WgQ0ysxp9ba6BUNXYDmQVkWZdVT+EF5YENgVQxo8FanQXYVZQfJnqdAvDHIETEFWn/pd96vAdMx+pjdm6GzDDK0D4RIgEP4X/yURCdvIkBAAAAAASUVORK5CYII=) no-repeat 50% 50%/auto 100%
}

.lottery .mask .c2 .cm>div.active {
    color: #fff;
    background: url(data:image/png;base64,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) no-repeat 50%/auto 100%
}

@keyframes moves-548d6309 {
    0% {
        opacity: 0
    }

    to {
        opacity: 1
    }
}

.lottery .foot {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 3.2rem;
    background: #fff;
    padding: 0 3%;
    display: flex;
    justify-content: flex-end;
    align-items: center
}

.lottery .foot p {
    padding-right: .66667rem;
    font-size: .86667rem;
    color: #302697
}

.lottery .foot p span {
    color: #ef41b1;
    padding: 0 .33333rem
}

.lottery .foot a {
    background: linear-gradient(20deg,#8673e5,#d958a4);
    color: #fff;
    border-radius: .33333rem;
    padding: .53333rem 1.33333rem;
    font-size: 1rem
}

.lottery .van-nav-bar {
    width: 100%
}

.lottery .top {
    width: 100%;
    padding: 1rem .66667rem .66667rem;
    position: relative;
    z-index: 10;
    background: linear-gradient(90deg,rgba(223,53,173,.8),rgba(79,29,181,.8));
    display: none; /* 隐藏顶部区域 */
}

.lottery .top .qs {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: .46667rem
}

.lottery .top .qs>span {
    color: #f4d70a;
    font-size: 1.1rem;
	display: flex;
}
.lottery .top .qs>span .van-count-down {
    color: #f4d70a;
    font-size: 1.1rem
}

.lottery .top .qs>div {
    display: flex;
    justify-content: flex-start;
    align-items: center
}

.lottery .top .qs>div h1 {
    font-size: .96667rem;
    color: #fff;
    padding-left: .66667rem
}

.lottery .top .qs>div .ico {
    width: 3.33333rem;
    height: 3.33333rem;
    overflow: hidden
}

.lottery .top .qs>div .ico img {
    width: 100%
}

.lottery .top .number {
    padding: .66667rem .66667rem;
    background: #f47cd5
}

.lottery .top .number .right,.lottery .top .number {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: .26667rem
}

.lottery .top .number .right {
    width: 60%;
    background: #fff;
    height: 2.66667rem;
    padding: 0 .66667rem;
    position: relative
}

.lottery .top .number .right:before {
    content: "";
    position: absolute;
    left: -1rem;
    width: 2PX;
    height: 2rem;
    background: #f9b1e7
}

.lottery .top .number .right .res {
    display: flex;
    justify-content: center;
    align-items: center
}

.lottery .top .number .right .res span {
    width: 2rem;
    height: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    color: #fff;
    margin-right: .86667rem;
    background: linear-gradient(90deg,#8b73e6,#d75db4)
}

.lottery .top .number .left {
    display: flex;
    justify-content: flex-start;
    align-items: center
}

.lottery .top .number .left .res {
    width: 6.66667rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: .33333rem
}

.lottery .top .number .left .res span {
    font-size: .93333rem;
    font-weight: 600
}

.lottery .top .number .left .ball,.lottery .top .number .left .ball p {
    display: flex;
    justify-content: flex-start;
    align-items: center
}

.lottery .top .number .left .ball p {
    height: 1.8rem;
    width: 6.93333rem;
    font-size: .8rem;
    color: #fff;
    font-weight: 600
}

.lottery .top .number .left .ball span {
    width: 2.33333rem;
    height: 2.33333rem
}

.lottery .top .number .left .ball span.idem4 {
    background: url(/img/4.png) no-repeat 50%/100%
}

.lottery .top .number .left .ball span.idem1 {
    background: url(/img/1.png) no-repeat 50%/100%
}

.lottery .top .number .left .ball span.idem2 {
    background: url(/img/2.png) no-repeat 50%/100%
}

.lottery .top .number .left .ball span.idem3 {
    background: url(/img/3.png) no-repeat 50%/100%
}

.lottery .top .number .left .ball span.idem5 {
    background: url(/img/5.png) no-repeat 50%/100%
}

.lottery .top .number .left .ball span.idem6 {
    background: url(/img/6.png) no-repeat 50%/100%
}

.lottery .history {
    position: absolute;
    width: 100%;
    height: calc(100% - 11.66667rem);
    background: rgba(0,0,0,.2);
    z-index: 9;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: flex-start
}

.lottery .history>div {
    overflow-y: auto;
    width: 100%;
    height: 20rem;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-top: .66667rem
}

.lottery .history>div>div p {
    font-size: .76667rem;
    font-weight: 600
}

.lottery .history>div>div ul {
    width: 100%;
    padding-top: .66667rem
}

.lottery .history>div>div ul li {
    width: 100%;
    height: 2rem;
    display: flex;
    justify-content: center;
    align-items: center
}

.lottery .history>div .left {
    width: 7.33333rem
}

.lottery .history>div .right {
    flex: 1;
    background: #fff
}

.lottery .history>div .right ul li .res {
    width: 6.66667rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 1.33333rem
}

.lottery .history>div .right ul li .res span {
    font-size: .8rem;
    font-weight: 600;
    background: linear-gradient(90deg,#f560cd,#4f2b8a);
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    width: 1.66667rem;
    height: 1.66667rem
}

.lottery .history>div .right ul li .ball {
    display: flex;
    justify-content: flex-start;
    align-items: center
}

.lottery .history>div .right ul li .ball p {
    height: 1.8rem;
    width: 6.93333rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: .76667rem;
    color: #9b9a9a
}

.lottery .history>div .right ul li .ball span {
    width: 1.8rem;
    height: 1.8rem;
    margin-right: .5rem
}

.lottery .history>div .right ul li .ball span.idem4 {
    background: url(/img/4.png) no-repeat 50%/100%
}

.lottery .history>div .right ul li .ball span.idem1 {
    background: url(/img/1.png) no-repeat 50%/100%
}

.lottery .history>div .right ul li .ball span.idem2 {
    background: url(/img/2.png) no-repeat 50%/100%
}

.lottery .history>div .right ul li .ball span.idem3 {
    background: url(/img/3.png) no-repeat 50%/100%
}

.lottery .history>div .right ul li .ball span.idem5 {
    background: url(/img/5.png) no-repeat 50%/100%
}

.lottery .history>div .right ul li .ball span.idem6 {
    background: url(/img/6.png) no-repeat 50%/100%
}

.lottery .lottery-content {
    width: 100%;
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    background: #f0f0f0;
    overflow: hidden
}

.lottery .lottery-content .left {
    width: 6.06667rem;
    height: 100%;
    background: #fff;
    padding-top: 1rem;
    border-top: 1rem solid #f0f0f0;
    display: none
}

.lottery .lottery-content .left .item {
    width: 100%
}

.lottery .lottery-content .left .item:first-child span {
    border-radius: 0 .33333rem 0 0
}

.lottery .lottery-content .left .item span {
    width: 100%;
    background: #f3cb76;
    color: #fff;
    display: inline-block;
    font-size: .83333rem;
    padding: .66667rem 0
}

.lottery .lottery-content .left .item>.slide {
    padding: 1rem 0;
    background: #fff
}

.lottery .lottery-content .left .item>.slide.active {
    background: #ece6eb;
    color: #7e5678;
    position: relative;
    overflow: hidden
}

.lottery .lottery-content .left .item>.slide.active:after {
    content: "";
    position: absolute;
    width: 1rem;
    height: 1rem;
    right: -.66667rem;
    top: 0;
    bottom: 0;
    margin: auto;
    background: #fff;
    transform: rotate(50deg)
}

.lottery .lottery-content .right {
    flex: 1;
    height: 100%;
    overflow-y: auto
}

.lottery .lottery-content .right .ball {
    align-items: center;
    padding: 5% 5% 4rem;
    position: relative
}

.lottery .lottery-content .right .ball>div,.lottery .lottery-content .right .ball {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap
}

.lottery .lottery-content .right .ball>div .idx0 {
    width: 46%;
    height: 5.2rem;
    background: #fff;
    border-radius: .33333rem;
    margin-bottom: 5%;
    box-shadow: 0 0 .33333rem rgba(0,0,0,.1);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative
}

.lottery .lottery-content .right .ball>div .idx0.active {
    background: #d07ac7
}

.lottery .lottery-content .right .ball>div .idx0.active:after {
    opacity: .2
}

.lottery .lottery-content .right .ball>div .idx0.active p,.lottery .lottery-content .right .ball>div .idx0.active span {
    position: relative;
    z-index: 99;
    color: #fff
}

/* 同街认证 - 绿色背景 */
.lottery .lottery-content .right .ball>div .idx0.auth-street {
    background: #4caf50 !important;
    border: 2px solid #4caf50;
}

.lottery .lottery-content .right .ball>div .idx0.auth-street p,
.lottery .lottery-content .right .ball>div .idx0.auth-street span {
    color: #fff !important;
}

/* 同国认证 - 红色背景 */
.lottery .lottery-content .right .ball>div .idx0.auth-country {
    background: #f44336 !important;
    border: 2px solid #f44336;
}

.lottery .lottery-content .right .ball>div .idx0.auth-country p,
.lottery .lottery-content .right .ball>div .idx0.auth-country span {
    color: #fff !important;
}

.lottery .lottery-content .right .ball>div .idx0 p {
    color: rgba(255,37,63,.9);
    font-size: 1.16667rem;
    font-weight: 600
}

.lottery .lottery-content .right .ball>div .idx0 span {
    color: #ff253f;
    font-size: .76667rem;
    padding-top: .66667rem
}

.lottery .lottery-content .right .ball .idx1 {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    align-items: center;
    padding-top: 1.33333rem
}

.lottery .lottery-content .right .ball .idx1.ebth {
    display: flex;
    flex-direction: column;
    padding-top: 0
}

.lottery .lottery-content .right .ball .idx1.ebth>div {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    position: relative;
    padding-top: 2rem;
    padding-bottom: .66667rem
}

.lottery .lottery-content .right .ball .idx1.ebth>div>div {
    width: 25%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 5%
}

.lottery .lottery-content .right .ball .idx1.ebth>div>div.active p {
    background: #d07ac7;
    color: #fff
}

.lottery .lottery-content .right .ball .idx1.ebth>div>span {
    position: absolute;
    top: 0;
    left: 0;
    color: #b4b4b5
}

.lottery .lottery-content .right .ball .idx1>span {
    position: absolute;
    top: .66667rem;
    left: .66667rem;
    color: #b4b4b5
}

.lottery .lottery-content .right .ball .idx1>div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 25%;
    margin-bottom: 5%
}

.lottery .lottery-content .right .ball .idx1>div.active p {
    background: #ff253f;
    color: #fff
}

.lottery .lottery-content .right .ball .idx1>div p {
    width: 3.33333rem;
    height: 3.33333rem;
    background: #fff;
    color: #7d7c7c;
    border-radius: 50%;
    font-size: 1.03333rem;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 0 .33333rem rgba(0,0,0,.04)
}

.popups {
    width: 90%;
    padding: 2.66667rem .66667rem 0;
    background: #e4e4e7;
    margin: .66667rem auto;
    border-radius: .33333rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    position: relative
}

.popups>p {
    position: absolute;
    font-weight: 600;
    font-size: .93333rem;
    top: .66667rem;
    left: .66667rem
}

.popups .ite {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 50%;
    padding-bottom: .66667rem
}

.popups .ite div {
    width: 3.33333rem;
    height: 3.33333rem;
    overflow: hidden;
    border-radius: .6rem
}

.popups .ite div img {
    width: 100%
}

.popups .ite p {
    font-size: .86667rem;
    padding: .66667rem 0
}


.van-icon {
  font-size: 1.3rem;
}
.down {
  transition: all .5s;
}
.up{
  transform: rotate(180deg);
  transition: all .5s;
}


.confirm-order-modal{
  position: unset;
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 0 20px 30px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 20rem;
  height: 22rem;
  max-height: 50%;
  z-index: 10;
  background-color: #fff;
  border-radius: 0.1rem;
}
.confirm-order-modal .head{
  position: relative;
  height: 80px;
}
.confirm-order-modal .head .text{
  padding: 0 0.2rem;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  font-size: 1.1rem;
  font-weight: 500;
  color: #3d359c;
}
::v-deep .confirm-order-modal .van-hairline--bottom::after {
  border-bottom-width: 2px;
}
.van-popup--center {
  border-radius: 0.3rem;
}
.confirm-order-modal .list{
  flex: 1;
  padding: 0 10px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.confirm-order-modal .list .lise-item{
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 0;
}
.confirm-order-modal .list .lise-item .main{
  flex: 1;
  overflow: hidden;
}
.confirm-order-modal .list .lise-item .main .bet-name{
  color: #ff253f;
  font-size: 1rem;
  font-weight: 500;
  line-height:2rem;
  word-wrap: break-word;
  word-break: break-all;
}
.confirm-order-modal .list .lise-item .main  .detail-text{
  line-height: 1.5rem;
  font-size: 25px;
  color: #3d359c;
}
.confirm-order-modal .list .lise-item{
  color: #ff253f;
}
.confirm-order-modal .sub-bar{
  display: flex;
  align-items: center;
  margin-top: 30px;
  justify-content: space-around;
}
.confirm-order-modal .sub-bar .item{
  min-width: 40%;
  height: 2.5rem;
  text-align: center;
  box-sizing: border-box;
  border-radius: 0.3rem;
  font-size: 1.2rem;
  font-weight: 500;
}
.confirm-order-modal .sub-bar .item.cancel-btn{
  border: 2px solid #979799;
  color: #979799;
  background-color: #fff;
}
.confirm-order-modal .sub-bar .item.sub-btn{
  background: linear-gradient(20deg, #8673e5, #d958a4);
  color: #fff;
  border: 0;
}
.next-number span{
  font-size: 35px;
  font-weight: 700;
  color: #000;
  float: right;
}

/* 认证界面样式 - 底部上拉 */
.auth-modal-popup {
  z-index: 3000;
  touch-action: pan-y; /* 允许垂直滚动，避免被动事件监听器警告 */
}

/* 修复van-popup的被动事件监听器警告 */
.auth-modal-popup .van-popup {
  touch-action: pan-y;
}

.auth-modal-popup .van-overlay {
  touch-action: pan-y;
}

.auth-modal {
  width: 100%;
  background: #fff;
  border-radius: 0.5rem 0.5rem 0 0;
  min-height: auto;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  touch-action: pan-y; /* 允许垂直滚动 */
}

.auth-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.2rem;
  border-bottom: 1px solid #eee;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 10;
  flex-shrink: 0;
}

.auth-header .van-icon {
  font-size: 1.3rem;
  color: #333;
  cursor: pointer;
}

.auth-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.auth-content {
  padding: 1.2rem;
  flex: 0 1 auto; /* 不自动扩展，根据内容自适应 */
  overflow-y: auto;
  min-height: 0; /* 允许flex子元素缩小 */
  -webkit-overflow-scrolling: touch;
  display: flex;
  flex-direction: column;
  touch-action: pan-y; /* 允许垂直滚动，避免被动事件监听器警告 */
  padding-bottom: 0; /* 移除底部padding，让内容紧贴 */
}

.auth-type-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.8rem 0;
  border-bottom: 1px solid #eee;
  margin-bottom: 1rem;
}

.auth-type-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
}

.auth-type-header .van-icon {
  font-size: 1.2rem;
  color: #999;
  cursor: pointer;
}

.auth-section {
  margin-bottom: 1.2rem;
}

.section-label {
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 0.8rem;
  font-weight: 500;
}

/* 货币行情显示区域样式 */
.auth-quote-section {
  margin-bottom: 1.2rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 0.5rem;
}

.quote-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.8rem;
}

.quote-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.6rem 1rem;
  background: #fff;
  border-radius: 0.4rem;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  min-width: 140px;
  flex: 1;
  flex-basis: calc(50% - 0.4rem);
}

.quote-pair {
  font-size: 0.9rem;
  color: #333;
  font-weight: 500;
  margin-right: 0.5rem;
}

.quote-price {
  font-size: 1rem;
  font-weight: 600;
  transition: color 0.3s ease;
}

.quote-price.price-up {
  color: #4caf50; /* 绿色 - 上涨 */
}

.quote-price.price-down {
  color: #f44336; /* 红色 - 下跌 */
}

.quote-price:not(.price-up):not(.price-down) {
  color: #666; /* 灰色 - 不变 */
}

/* 货币行情显示区域样式 - 主页面 */
.lottery-content .right .main-quote-section {
  margin: -50px 5% 0 5%; /* 上边距20px，与按钮保持间距 */
  padding: 1rem;
  background: #fff;
  border-radius: 0.5rem;
  width: auto;
  border: 2px solid #f44336; /* 红色边框 */
  min-height: 200px; /* 确保有足够的高度 */
  box-sizing: border-box;
}

.main-quote-section .quote-section-title {
  font-size: 1rem;
  color: #333;
  font-weight: 600;
  margin-bottom: 1rem;
  text-align: center;
}

.main-quote-section .quote-list {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.main-quote-section .quote-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.6rem 1rem;
  background: #f8f9fa;
  border-radius: 0.4rem;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  width: 100%;
}

.auth-duration-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
}

.auth-duration-item {
  flex: 1;
  min-width: calc(20% - 0.48rem);
  padding: 0.8rem 0.5rem;
  text-align: center;
  border: 1px solid #ddd;
  border-radius: 0.3rem;
  background: #f5f5f5;
  color: #333;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s;
  box-sizing: border-box;
}

.auth-duration-item.active {
  background: #ff253f;
  color: #fff;
  border-color: #ff253f;
  font-weight: 600;
}

.auth-amount-input {
  width: 100%;
  position: relative;
}

.amount-input {
  width: 100%;
  padding: 1rem;
  border: 1px solid #ddd;
  border-radius: 0.3rem;
  font-size: 1rem;
  box-sizing: border-box;
  background: #fff;
}

.amount-input:focus {
  outline: none;
  border-color: #ff253f;
}

.auth-balance {
  padding: 0.8rem 0;
  font-size: 0.95rem;
  color: #666;
  border-bottom: 1px solid #eee;
  margin-bottom: 1rem;
}

.auth-balance span {
  color: #ff253f;
  font-weight: 600;
  font-size: 1rem;
}

.auth-table {
  margin-bottom: 0;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  flex-shrink: 0;
  touch-action: pan-x; /* 允许水平滚动 */
  flex-grow: 0; /* 不自动扩展，保持内容紧凑 */
}

.auth-table table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.auth-table th,
.auth-table td {
  padding: 0.8rem 0.5rem;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.auth-table th {
  background: #f5f5f5;
  font-weight: 600;
  color: #333;
  font-size: 0.8rem;
  white-space: nowrap;
}

.auth-table td {
  color: #666;
  font-size: 0.85rem;
}

.price-cell {
  color: #ff253f !important;
  font-weight: 600;
}

.auth-submit {
  padding: 1rem 1.2rem 1.5rem;
  background: #fff;
  flex-shrink: 0;
  margin-top: 0; /* 紧贴表格，不留空白 */
  position: sticky;
  bottom: 0;
  border-top: 1px solid #f0f0f0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}

.submit-btn {
  width: 100%;
  height: 3rem;
  background: linear-gradient(20deg, #8673e5, #d958a4);
  border: none;
  border-radius: 0.4rem;
  color: #fff;
  font-size: 1.1rem;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(134, 115, 229, 0.3);
}

/* 等待结果弹窗样式 */
.waiting-modal-popup {
  z-index: 3001;
}

.waiting-result-modal {
  background: #fff;
  border-radius: 0.5rem 0.5rem 0 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 60vh;
}

/* 顶部标题栏 */
.waiting-header-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.2rem;
  background: linear-gradient(90deg, rgba(223,53,173,.8), rgba(79,29,181,.8));
}

.waiting-header-bar .van-icon {
  font-size: 1.3rem;
  color: #fff;
  cursor: pointer;
}

.waiting-header-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #fff;
  margin: 0;
}

/* 内容区域 */
.waiting-content-wrapper {
  padding: 1.5rem;
  flex: 1;
  display: flex;
  flex-direction: column;
}

/* 彩种标题 */
.waiting-lottery-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #000;
  margin-bottom: 2rem;
  text-align: left;
}

/* 等待状态 */
.waiting-status {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 大的圆形倒计时器 */
.countdown-circle-large {
  width: 200px;
  height: 200px;
  margin: 0 auto 2rem;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.countdown-svg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}

.countdown-circle-bg {
  opacity: 0.2;
}

.countdown-circle-progress {
  transition: stroke-dashoffset 0.5s linear;
}

.countdown-number-large {
  font-size: 2rem;
  font-weight: 700;
  color: #000;
  line-height: 1;
  position: relative;
  z-index: 1;
}

/* 数据列表 */
.waiting-data-list {
  width: 100%;
  margin-top: 1rem;
}

.data-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  border-bottom: 1px solid #f0f0f0;
}

.data-item:last-child {
  border-bottom: none;
}

.data-label {
  font-size: 0.95rem;
  color: #666;
  font-weight: 500;
}

.data-value {
  font-size: 0.95rem;
  color: #000;
  font-weight: 600;
}

.data-value.price-value {
  color: #ff253f;
}

.data-value.type-value {
  color: #4caf50;
}

.data-value.profit-value {
  color: #4caf50;
}

.data-value.profit-value.profit-positive {
  color: #4caf50;
}

.data-value.profit-value.profit-negative {
  color: #f44336;
}

/* 底部状态栏 */
.waiting-footer-bar {
  width: 100%;
  padding: 1rem;
  background: #f5f5f5;
  text-align: center;
  margin-top: auto;
  border-radius: 0.3rem;
}

.waiting-footer-bar span {
  font-size: 0.95rem;
  color: #333;
}

/* 结果显示 */
.result-status {
  width: 100%;
  text-align: center;
  padding: 2rem 0;
}

.result-icon {
  width: 100px;
  height: 100px;
  margin: 0 auto 1.5rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3rem;
}

.result-icon.win {
  background: #4caf50;
  color: #fff;
}

.result-icon.lose {
  background: #f44336;
  color: #fff;
}

.result-text {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0.5rem 0;
}

.result-text.win {
  color: #4caf50;
}

.result-text.lose {
  color: #f44336;
}

.result-message {
  font-size: 0.95rem;
  color: #666;
  margin: 0.5rem 0;
}

.result-profit {
  font-size: 1rem;
  color: #333;
  margin-top: 1rem;
}

.result-profit span.win {
  color: #4caf50;
  font-weight: 600;
}

.result-profit span.lose {
  color: #f44336;
  font-weight: 600;
}

.result-profit span.profit-positive {
  color: #4caf50;
  font-weight: 600;
  font-size: 1.2rem;
}

.result-profit span.profit-negative {
  color: #f44336;
  font-weight: 600;
  font-size: 1.2rem;
}

.result-close-btn-wrapper {
  margin-top: 2rem;
  padding: 0 1.5rem;
}

.result-close-btn {
  width: 100%;
  height: 2.8rem;
  background: linear-gradient(20deg, #8673e5, #d958a4);
  border: none;
  border-radius: 0.4rem;
  color: #fff;
  font-size: 1rem;
  font-weight: 600;
}
</style>
